(() => {
  // node_modules/@googlemaps/markerclusterer/node_modules/fast-equals/dist/es/index.mjs
  var { getOwnPropertyNames, getOwnPropertySymbols } = Object;
  var { hasOwnProperty } = Object.prototype;
  function combineComparators(comparatorA, comparatorB) {
    return function isEqual(a, b, state) {
      return comparatorA(a, b, state) && comparatorB(a, b, state);
    };
  }
  function createIsCircular(areItemsEqual) {
    return function isCircular(a, b, state) {
      if (!a || !b || typeof a !== "object" || typeof b !== "object") {
        return areItemsEqual(a, b, state);
      }
      const { cache } = state;
      const cachedA = cache.get(a);
      const cachedB = cache.get(b);
      if (cachedA && cachedB) {
        return cachedA === b && cachedB === a;
      }
      cache.set(a, b);
      cache.set(b, a);
      const result = areItemsEqual(a, b, state);
      cache.delete(a);
      cache.delete(b);
      return result;
    };
  }
  function getShortTag(value) {
    return value != null ? value[Symbol.toStringTag] : void 0;
  }
  function getStrictProperties(object) {
    return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
  }
  var hasOwn = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    Object.hasOwn || ((object, property) => hasOwnProperty.call(object, property))
  );
  function sameValueZeroEqual(a, b) {
    return a === b || !a && !b && a !== a && b !== b;
  }
  var PREACT_VNODE = "__v";
  var PREACT_OWNER = "__o";
  var REACT_OWNER = "_owner";
  var { getOwnPropertyDescriptor, keys } = Object;
  function areArrayBuffersEqual(a, b) {
    return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
  }
  function areArraysEqual(a, b, state) {
    let index = a.length;
    if (b.length !== index) {
      return false;
    }
    while (index-- > 0) {
      if (!state.equals(a[index], b[index], index, index, a, b, state)) {
        return false;
      }
    }
    return true;
  }
  function areDataViewsEqual(a, b) {
    return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
  }
  function areDatesEqual(a, b) {
    return sameValueZeroEqual(a.getTime(), b.getTime());
  }
  function areErrorsEqual(a, b) {
    return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
  }
  function areFunctionsEqual(a, b) {
    return a === b;
  }
  function areMapsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) {
      return false;
    }
    if (!size) {
      return true;
    }
    const matchedIndices = new Array(size);
    const aIterable = a.entries();
    let aResult;
    let bResult;
    let index = 0;
    while (aResult = aIterable.next()) {
      if (aResult.done) {
        break;
      }
      const bIterable = b.entries();
      let hasMatch = false;
      let matchIndex = 0;
      while (bResult = bIterable.next()) {
        if (bResult.done) {
          break;
        }
        if (matchedIndices[matchIndex]) {
          matchIndex++;
          continue;
        }
        const aEntry = aResult.value;
        const bEntry = bResult.value;
        if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
          hasMatch = matchedIndices[matchIndex] = true;
          break;
        }
        matchIndex++;
      }
      if (!hasMatch) {
        return false;
      }
      index++;
    }
    return true;
  }
  var areNumbersEqual = sameValueZeroEqual;
  function areObjectsEqual(a, b, state) {
    const properties = keys(a);
    let index = properties.length;
    if (keys(b).length !== index) {
      return false;
    }
    while (index-- > 0) {
      if (!isPropertyEqual(a, b, state, properties[index])) {
        return false;
      }
    }
    return true;
  }
  function areObjectsEqualStrict(a, b, state) {
    const properties = getStrictProperties(a);
    let index = properties.length;
    if (getStrictProperties(b).length !== index) {
      return false;
    }
    let property;
    let descriptorA;
    let descriptorB;
    while (index-- > 0) {
      property = properties[index];
      if (!isPropertyEqual(a, b, state, property)) {
        return false;
      }
      descriptorA = getOwnPropertyDescriptor(a, property);
      descriptorB = getOwnPropertyDescriptor(b, property);
      if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) {
        return false;
      }
    }
    return true;
  }
  function arePrimitiveWrappersEqual(a, b) {
    return sameValueZeroEqual(a.valueOf(), b.valueOf());
  }
  function areRegExpsEqual(a, b) {
    return a.source === b.source && a.flags === b.flags;
  }
  function areSetsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) {
      return false;
    }
    if (!size) {
      return true;
    }
    const matchedIndices = new Array(size);
    const aIterable = a.values();
    let aResult;
    let bResult;
    while (aResult = aIterable.next()) {
      if (aResult.done) {
        break;
      }
      const bIterable = b.values();
      let hasMatch = false;
      let matchIndex = 0;
      while (bResult = bIterable.next()) {
        if (bResult.done) {
          break;
        }
        if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
          hasMatch = matchedIndices[matchIndex] = true;
          break;
        }
        matchIndex++;
      }
      if (!hasMatch) {
        return false;
      }
    }
    return true;
  }
  function areTypedArraysEqual(a, b) {
    let index = a.byteLength;
    if (b.byteLength !== index || a.byteOffset !== b.byteOffset) {
      return false;
    }
    while (index-- > 0) {
      if (a[index] !== b[index]) {
        return false;
      }
    }
    return true;
  }
  function areUrlsEqual(a, b) {
    return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
  }
  function isPropertyEqual(a, b, state, property) {
    if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) {
      return true;
    }
    return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
  }
  var ARRAY_BUFFER_TAG = "[object ArrayBuffer]";
  var ARGUMENTS_TAG = "[object Arguments]";
  var BOOLEAN_TAG = "[object Boolean]";
  var DATA_VIEW_TAG = "[object DataView]";
  var DATE_TAG = "[object Date]";
  var ERROR_TAG = "[object Error]";
  var MAP_TAG = "[object Map]";
  var NUMBER_TAG = "[object Number]";
  var OBJECT_TAG = "[object Object]";
  var REG_EXP_TAG = "[object RegExp]";
  var SET_TAG = "[object Set]";
  var STRING_TAG = "[object String]";
  var TYPED_ARRAY_TAGS = {
    "[object Int8Array]": true,
    "[object Uint8Array]": true,
    "[object Uint8ClampedArray]": true,
    "[object Int16Array]": true,
    "[object Uint16Array]": true,
    "[object Int32Array]": true,
    "[object Uint32Array]": true,
    "[object Float16Array]": true,
    "[object Float32Array]": true,
    "[object Float64Array]": true,
    "[object BigInt64Array]": true,
    "[object BigUint64Array]": true
  };
  var URL_TAG = "[object URL]";
  var toString = Object.prototype.toString;
  function createEqualityComparator({ areArrayBuffersEqual: areArrayBuffersEqual2, areArraysEqual: areArraysEqual2, areDataViewsEqual: areDataViewsEqual2, areDatesEqual: areDatesEqual2, areErrorsEqual: areErrorsEqual2, areFunctionsEqual: areFunctionsEqual2, areMapsEqual: areMapsEqual2, areNumbersEqual: areNumbersEqual2, areObjectsEqual: areObjectsEqual2, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual2, areRegExpsEqual: areRegExpsEqual2, areSetsEqual: areSetsEqual2, areTypedArraysEqual: areTypedArraysEqual2, areUrlsEqual: areUrlsEqual2, unknownTagComparators }) {
    return function comparator(a, b, state) {
      if (a === b) {
        return true;
      }
      if (a == null || b == null) {
        return false;
      }
      const type = typeof a;
      if (type !== typeof b) {
        return false;
      }
      if (type !== "object") {
        if (type === "number") {
          return areNumbersEqual2(a, b, state);
        }
        if (type === "function") {
          return areFunctionsEqual2(a, b, state);
        }
        return false;
      }
      const constructor = a.constructor;
      if (constructor !== b.constructor) {
        return false;
      }
      if (constructor === Object) {
        return areObjectsEqual2(a, b, state);
      }
      if (Array.isArray(a)) {
        return areArraysEqual2(a, b, state);
      }
      if (constructor === Date) {
        return areDatesEqual2(a, b, state);
      }
      if (constructor === RegExp) {
        return areRegExpsEqual2(a, b, state);
      }
      if (constructor === Map) {
        return areMapsEqual2(a, b, state);
      }
      if (constructor === Set) {
        return areSetsEqual2(a, b, state);
      }
      const tag = toString.call(a);
      if (tag === DATE_TAG) {
        return areDatesEqual2(a, b, state);
      }
      if (tag === REG_EXP_TAG) {
        return areRegExpsEqual2(a, b, state);
      }
      if (tag === MAP_TAG) {
        return areMapsEqual2(a, b, state);
      }
      if (tag === SET_TAG) {
        return areSetsEqual2(a, b, state);
      }
      if (tag === OBJECT_TAG) {
        return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual2(a, b, state);
      }
      if (tag === URL_TAG) {
        return areUrlsEqual2(a, b, state);
      }
      if (tag === ERROR_TAG) {
        return areErrorsEqual2(a, b, state);
      }
      if (tag === ARGUMENTS_TAG) {
        return areObjectsEqual2(a, b, state);
      }
      if (TYPED_ARRAY_TAGS[tag]) {
        return areTypedArraysEqual2(a, b, state);
      }
      if (tag === ARRAY_BUFFER_TAG) {
        return areArrayBuffersEqual2(a, b, state);
      }
      if (tag === DATA_VIEW_TAG) {
        return areDataViewsEqual2(a, b, state);
      }
      if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) {
        return arePrimitiveWrappersEqual2(a, b, state);
      }
      if (unknownTagComparators) {
        let unknownTagComparator = unknownTagComparators[tag];
        if (!unknownTagComparator) {
          const shortTag = getShortTag(a);
          if (shortTag) {
            unknownTagComparator = unknownTagComparators[shortTag];
          }
        }
        if (unknownTagComparator) {
          return unknownTagComparator(a, b, state);
        }
      }
      return false;
    };
  }
  function createEqualityComparatorConfig({ circular, createCustomConfig, strict }) {
    let config = {
      areArrayBuffersEqual,
      areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
      areDataViewsEqual,
      areDatesEqual,
      areErrorsEqual,
      areFunctionsEqual,
      areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
      areNumbersEqual,
      areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
      arePrimitiveWrappersEqual,
      areRegExpsEqual,
      areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
      areTypedArraysEqual: strict ? combineComparators(areTypedArraysEqual, areObjectsEqualStrict) : areTypedArraysEqual,
      areUrlsEqual,
      unknownTagComparators: void 0
    };
    if (createCustomConfig) {
      config = Object.assign({}, config, createCustomConfig(config));
    }
    if (circular) {
      const areArraysEqual2 = createIsCircular(config.areArraysEqual);
      const areMapsEqual2 = createIsCircular(config.areMapsEqual);
      const areObjectsEqual2 = createIsCircular(config.areObjectsEqual);
      const areSetsEqual2 = createIsCircular(config.areSetsEqual);
      config = Object.assign({}, config, {
        areArraysEqual: areArraysEqual2,
        areMapsEqual: areMapsEqual2,
        areObjectsEqual: areObjectsEqual2,
        areSetsEqual: areSetsEqual2
      });
    }
    return config;
  }
  function createInternalEqualityComparator(compare) {
    return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
      return compare(a, b, state);
    };
  }
  function createIsEqual({ circular, comparator, createState, equals, strict }) {
    if (createState) {
      return function isEqual(a, b) {
        const { cache = circular ? /* @__PURE__ */ new WeakMap() : void 0, meta } = createState();
        return comparator(a, b, {
          cache,
          equals,
          meta,
          strict
        });
      };
    }
    if (circular) {
      return function isEqual(a, b) {
        return comparator(a, b, {
          cache: /* @__PURE__ */ new WeakMap(),
          equals,
          meta: void 0,
          strict
        });
      };
    }
    const state = {
      cache: void 0,
      equals,
      meta: void 0,
      strict
    };
    return function isEqual(a, b) {
      return comparator(a, b, state);
    };
  }
  var deepEqual = createCustomEqual();
  var strictDeepEqual = createCustomEqual({ strict: true });
  var circularDeepEqual = createCustomEqual({ circular: true });
  var strictCircularDeepEqual = createCustomEqual({
    circular: true,
    strict: true
  });
  var shallowEqual = createCustomEqual({
    createInternalComparator: () => sameValueZeroEqual
  });
  var strictShallowEqual = createCustomEqual({
    strict: true,
    createInternalComparator: () => sameValueZeroEqual
  });
  var circularShallowEqual = createCustomEqual({
    circular: true,
    createInternalComparator: () => sameValueZeroEqual
  });
  var strictCircularShallowEqual = createCustomEqual({
    circular: true,
    createInternalComparator: () => sameValueZeroEqual,
    strict: true
  });
  function createCustomEqual(options = {}) {
    const { circular = false, createInternalComparator: createCustomInternalComparator, createState, strict = false } = options;
    const config = createEqualityComparatorConfig(options);
    const comparator = createEqualityComparator(config);
    const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
    return createIsEqual({ circular, comparator, createState, equals, strict });
  }

  // node_modules/kdbush/index.js
  var ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
  ];
  var VERSION = 1;
  var HEADER_SIZE = 8;
  var STACK = new Uint32Array(96);
  var KDBush = class _KDBush {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBufferLike} data
     */
    static from(data) {
      if (!data || data.byteLength === void 0 || data.buffer) {
        throw new Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
      }
      const [magic, versionAndType] = new Uint8Array(data, 0, 2);
      if (magic !== 219) {
        throw new Error("Data does not appear to be in a KDBush format.");
      }
      const version = versionAndType >> 4;
      if (version !== VERSION) {
        throw new Error(`Got v${version} data when expected v${VERSION}.`);
      }
      const ArrayType = ARRAY_TYPES[versionAndType & 15];
      if (!ArrayType) {
        throw new Error("Unrecognized array type.");
      }
      const [nodeSize] = new Uint16Array(data, 2, 1);
      const [numItems] = new Uint32Array(data, 4, 1);
      return new _KDBush(numItems, nodeSize, ArrayType, void 0, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBufferConstructor | SharedArrayBufferConstructor} [ArrayBufferType=ArrayBuffer] The array buffer type used for storage (`ArrayBuffer` by default).
     * @param {ArrayBufferLike} [data] (For internal use only)
     */
    constructor(numItems, nodeSize = 64, ArrayType = Float64Array, ArrayBufferType = ArrayBuffer, data) {
      if (isNaN(numItems) || numItems < 0)
        throw new Error(`Unexpected numItems value: ${numItems}.`);
      this.numItems = +numItems;
      this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
      this.ArrayType = ArrayType;
      this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
      const arrayTypeIndex = ARRAY_TYPES.indexOf(this.ArrayType);
      const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
      const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
      const padCoords = (8 - idsByteSize % 8) % 8;
      if (arrayTypeIndex < 0) {
        throw new Error(`Unexpected typed array class: ${ArrayType}.`);
      }
      if (data) {
        this.data = data;
        this.ids = new this.IndexArrayType(data, HEADER_SIZE, numItems);
        this.coords = new ArrayType(data, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
        this._pos = numItems * 2;
        this._finished = true;
      } else {
        const data2 = this.data = new ArrayBufferType(HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
        this.ids = new this.IndexArrayType(data2, HEADER_SIZE, numItems);
        this.coords = new ArrayType(data2, HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
        this._pos = 0;
        this._finished = false;
        new Uint8Array(data2, 0, 2).set([219, (VERSION << 4) + arrayTypeIndex]);
        new Uint16Array(data2, 2, 1)[0] = nodeSize;
        new Uint32Array(data2, 4, 1)[0] = numItems;
      }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */
    add(x, y) {
      const index = this._pos >> 1;
      this.ids[index] = index;
      this.coords[this._pos++] = x;
      this.coords[this._pos++] = y;
      return index;
    }
    /**
     * Perform indexing of the added points.
     */
    finish() {
      const numAdded = this._pos >> 1;
      if (numAdded !== this.numItems) {
        throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
      }
      sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
      this._finished = true;
      return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */
    range(minX, minY, maxX, maxY) {
      if (!this._finished)
        throw new Error("Data not yet indexed - call index.finish().");
      const { ids, coords, nodeSize } = this;
      STACK[0] = 0;
      STACK[1] = ids.length - 1;
      STACK[2] = 0;
      let sp = 3;
      const result = [];
      while (sp > 0) {
        const axis = STACK[--sp];
        const right = STACK[--sp];
        const left = STACK[--sp];
        if (right - left <= nodeSize) {
          for (let i = left; i <= right; i++) {
            const x2 = coords[2 * i];
            const y2 = coords[2 * i + 1];
            if (x2 >= minX && x2 <= maxX && y2 >= minY && y2 <= maxY)
              result.push(ids[i]);
          }
          continue;
        }
        const m = left + right >> 1;
        const x = coords[2 * m];
        const y = coords[2 * m + 1];
        if (x >= minX && x <= maxX && y >= minY && y <= maxY)
          result.push(ids[m]);
        if (axis === 0 ? minX <= x : minY <= y) {
          STACK[sp++] = left;
          STACK[sp++] = m - 1;
          STACK[sp++] = 1 - axis;
        }
        if (axis === 0 ? maxX >= x : maxY >= y) {
          STACK[sp++] = m + 1;
          STACK[sp++] = right;
          STACK[sp++] = 1 - axis;
        }
      }
      return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */
    within(qx, qy, r) {
      const result = (
        /** @type {number[]} */
        []
      );
      this.withinInto(qx, qy, r, result);
      return result;
    }
    /**
     * Search the index for items within a given radius, writing matching ids into `out`
     * via indexed assignment (`out[i] = id`). Accepts any indexed-writable container —
     * a typed array sized to the expected upper bound (allocation-free, fast) or a plain
     * `Array` (which will grow as needed). Returns the number of matches written.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @param {number[] | TypedArray} out Container to write matching ids into.
     * @returns {number} The number of matches written to `out`.
     */
    withinInto(qx, qy, r, out) {
      if (!this._finished)
        throw new Error("Data not yet indexed - call index.finish().");
      const { ids, coords, nodeSize } = this;
      STACK[0] = 0;
      STACK[1] = ids.length - 1;
      STACK[2] = 0;
      let sp = 3;
      let count = 0;
      const r2 = r * r;
      while (sp > 0) {
        const axis = STACK[--sp];
        const right = STACK[--sp];
        const left = STACK[--sp];
        if (right - left <= nodeSize) {
          for (let i = left; i <= right; i++) {
            if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2)
              out[count++] = ids[i];
          }
          continue;
        }
        const m = left + right >> 1;
        const x = coords[2 * m];
        const y = coords[2 * m + 1];
        if (sqDist(x, y, qx, qy) <= r2)
          out[count++] = ids[m];
        if (axis === 0 ? qx - r <= x : qy - r <= y) {
          STACK[sp++] = left;
          STACK[sp++] = m - 1;
          STACK[sp++] = 1 - axis;
        }
        if (axis === 0 ? qx + r >= x : qy + r >= y) {
          STACK[sp++] = m + 1;
          STACK[sp++] = right;
          STACK[sp++] = 1 - axis;
        }
      }
      return count;
    }
  };
  function sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize)
      return;
    const m = left + right >> 1;
    select(ids, coords, m, left, right, axis);
    sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
  }
  function select(ids, coords, k, left, right, axis) {
    while (right > left) {
      if (right - left > 600) {
        const n = right - left + 1;
        const m = k - left + 1;
        const z = Math.log(n);
        const s = 0.5 * Math.exp(2 * z / 3);
        const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
        const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
        const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
        select(ids, coords, k, newLeft, newRight, axis);
      }
      const t = coords[2 * k + axis];
      let i = left;
      let j = right;
      swapItem(ids, coords, left, k);
      if (coords[2 * right + axis] > t)
        swapItem(ids, coords, left, right);
      while (i < j) {
        swapItem(ids, coords, i, j);
        i++;
        j--;
        while (coords[2 * i + axis] < t)
          i++;
        while (coords[2 * j + axis] > t)
          j--;
      }
      if (coords[2 * left + axis] === t)
        swapItem(ids, coords, left, j);
      else {
        j++;
        swapItem(ids, coords, j, right);
      }
      if (j <= k)
        left = j + 1;
      if (k <= j)
        right = j - 1;
    }
  }
  function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
  }
  function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
  }
  function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
  }

  // node_modules/supercluster/index.js
  var defaultOptions = {
    minZoom: 0,
    // min zoom to generate clusters on
    maxZoom: 16,
    // max zoom level to cluster the points on
    minPoints: 2,
    // minimum points to form a cluster
    radius: 40,
    // cluster radius in pixels
    extent: 512,
    // tile extent (radius is calculated relative to it)
    nodeSize: 64,
    // size of the KD-tree leaf node, affects performance
    log: false,
    // whether to log timing info
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // (accumulated, props) => { accumulated.sum += props.sum; }
    // properties to use for individual points when running the reducer
    map: (props) => props
    // props => ({sum: props.my_value})
  };
  var fround = Math.fround || /* @__PURE__ */ ((tmp) => (x) => {
    tmp[0] = +x;
    return tmp[0];
  })(new Float32Array(1));
  var OFFSET_ZOOM = 2;
  var OFFSET_ID = 3;
  var OFFSET_PARENT = 4;
  var OFFSET_NUM = 5;
  var OFFSET_PROP = 6;
  var Supercluster = class {
    constructor(options) {
      this.options = Object.assign(Object.create(defaultOptions), options);
      this.trees = new Array(this.options.maxZoom + 1);
      this.stride = this.options.reduce ? 7 : 6;
      this.clusterProps = [];
    }
    load(points) {
      const { log, minZoom, maxZoom } = this.options;
      if (log)
        console.time("total time");
      const timerId = `prepare ${points.length} points`;
      if (log)
        console.time(timerId);
      this.points = points;
      const data = [];
      for (let i = 0; i < points.length; i++) {
        const p = points[i];
        if (!p.geometry)
          continue;
        const [lng, lat] = p.geometry.coordinates;
        const x = fround(lngX(lng));
        const y = fround(latY(lat));
        data.push(
          x,
          y,
          // projected point coordinates
          Infinity,
          // the last zoom the point was processed at
          i,
          // index of the source feature in the original input array
          -1,
          // parent cluster id
          1
          // number of points in a cluster
        );
        if (this.options.reduce)
          data.push(0);
      }
      let tree = this.trees[maxZoom + 1] = this._createTree(data);
      if (log)
        console.timeEnd(timerId);
      for (let z = maxZoom; z >= minZoom; z--) {
        const now = +Date.now();
        tree = this.trees[z] = this._createTree(this._cluster(tree, z));
        if (log)
          console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
      }
      if (log)
        console.timeEnd("total time");
      return this;
    }
    getClusters(bbox, zoom) {
      let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
      const minLat = Math.max(-90, Math.min(90, bbox[1]));
      let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
      const maxLat = Math.max(-90, Math.min(90, bbox[3]));
      if (bbox[2] - bbox[0] >= 360) {
        minLng = -180;
        maxLng = 180;
      } else if (minLng > maxLng) {
        const easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
        const westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
        return easternHem.concat(westernHem);
      }
      const tree = this.trees[this._limitZoom(zoom)];
      const ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
      const data = tree.data;
      const clusters = [];
      for (const id of ids) {
        const k = this.stride * id;
        clusters.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
      }
      return clusters;
    }
    getChildren(clusterId) {
      const originId = this._getOriginId(clusterId);
      const originZoom = this._getOriginZoom(clusterId);
      const errorMsg = "No cluster with the specified id.";
      const tree = this.trees[originZoom];
      if (!tree)
        throw new Error(errorMsg);
      const data = tree.data;
      if (originId * this.stride >= data.length)
        throw new Error(errorMsg);
      const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
      const x = data[originId * this.stride];
      const y = data[originId * this.stride + 1];
      const ids = tree.within(x, y, r);
      const children = [];
      for (const id of ids) {
        const k = id * this.stride;
        if (data[k + OFFSET_PARENT] === clusterId) {
          children.push(data[k + OFFSET_NUM] > 1 ? getClusterJSON(data, k, this.clusterProps) : this.points[data[k + OFFSET_ID]]);
        }
      }
      if (children.length === 0)
        throw new Error(errorMsg);
      return children;
    }
    getLeaves(clusterId, limit, offset) {
      limit = limit || 10;
      offset = offset || 0;
      const leaves = [];
      this._appendLeaves(leaves, clusterId, limit, offset, 0);
      return leaves;
    }
    getTile(z, x, y) {
      const tree = this.trees[this._limitZoom(z)];
      const z2 = Math.pow(2, z);
      const { extent, radius } = this.options;
      const p = radius / extent;
      const top = (y - p) / z2;
      const bottom = (y + 1 + p) / z2;
      const tile = {
        features: []
      };
      this._addTileFeatures(
        tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
        tree.data,
        x,
        y,
        z2,
        tile
      );
      if (x === 0) {
        this._addTileFeatures(
          tree.range(1 - p / z2, top, 1, bottom),
          tree.data,
          z2,
          y,
          z2,
          tile
        );
      }
      if (x === z2 - 1) {
        this._addTileFeatures(
          tree.range(0, top, p / z2, bottom),
          tree.data,
          -1,
          y,
          z2,
          tile
        );
      }
      return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
      let expansionZoom = this._getOriginZoom(clusterId) - 1;
      while (expansionZoom <= this.options.maxZoom) {
        const children = this.getChildren(clusterId);
        expansionZoom++;
        if (children.length !== 1)
          break;
        clusterId = children[0].properties.cluster_id;
      }
      return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
      const children = this.getChildren(clusterId);
      for (const child of children) {
        const props = child.properties;
        if (props && props.cluster) {
          if (skipped + props.point_count <= offset) {
            skipped += props.point_count;
          } else {
            skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
          }
        } else if (skipped < offset) {
          skipped++;
        } else {
          result.push(child);
        }
        if (result.length === limit)
          break;
      }
      return skipped;
    }
    _createTree(data) {
      const tree = new KDBush(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
      for (let i = 0; i < data.length; i += this.stride)
        tree.add(data[i], data[i + 1]);
      tree.finish();
      tree.data = data;
      return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
      for (const i of ids) {
        const k = i * this.stride;
        const isCluster = data[k + OFFSET_NUM] > 1;
        let tags, px, py;
        if (isCluster) {
          tags = getClusterProperties(data, k, this.clusterProps);
          px = data[k];
          py = data[k + 1];
        } else {
          const p = this.points[data[k + OFFSET_ID]];
          tags = p.properties;
          const [lng, lat] = p.geometry.coordinates;
          px = lngX(lng);
          py = latY(lat);
        }
        const f = {
          type: 1,
          geometry: [[
            Math.round(this.options.extent * (px * z2 - x)),
            Math.round(this.options.extent * (py * z2 - y))
          ]],
          tags
        };
        let id;
        if (isCluster || this.options.generateId) {
          id = data[k + OFFSET_ID];
        } else {
          id = this.points[data[k + OFFSET_ID]].id;
        }
        if (id !== void 0)
          f.id = id;
        tile.features.push(f);
      }
    }
    _limitZoom(z) {
      return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
      const { radius, extent, reduce, minPoints } = this.options;
      const r = radius / (extent * Math.pow(2, zoom));
      const data = tree.data;
      const nextData = [];
      const stride = this.stride;
      for (let i = 0; i < data.length; i += stride) {
        if (data[i + OFFSET_ZOOM] <= zoom)
          continue;
        data[i + OFFSET_ZOOM] = zoom;
        const x = data[i];
        const y = data[i + 1];
        const neighborIds = tree.within(data[i], data[i + 1], r);
        const numPointsOrigin = data[i + OFFSET_NUM];
        let numPoints = numPointsOrigin;
        for (const neighborId of neighborIds) {
          const k = neighborId * stride;
          if (data[k + OFFSET_ZOOM] > zoom)
            numPoints += data[k + OFFSET_NUM];
        }
        if (numPoints > numPointsOrigin && numPoints >= minPoints) {
          let wx = x * numPointsOrigin;
          let wy = y * numPointsOrigin;
          let clusterProperties;
          let clusterPropIndex = -1;
          const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
          for (const neighborId of neighborIds) {
            const k = neighborId * stride;
            if (data[k + OFFSET_ZOOM] <= zoom)
              continue;
            data[k + OFFSET_ZOOM] = zoom;
            const numPoints2 = data[k + OFFSET_NUM];
            wx += data[k] * numPoints2;
            wy += data[k + 1] * numPoints2;
            data[k + OFFSET_PARENT] = id;
            if (reduce) {
              if (!clusterProperties) {
                clusterProperties = this._map(data, i, true);
                clusterPropIndex = this.clusterProps.length;
                this.clusterProps.push(clusterProperties);
              }
              reduce(clusterProperties, this._map(data, k));
            }
          }
          data[i + OFFSET_PARENT] = id;
          nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
          if (reduce)
            nextData.push(clusterPropIndex);
        } else {
          for (let j = 0; j < stride; j++)
            nextData.push(data[i + j]);
          if (numPoints > 1) {
            for (const neighborId of neighborIds) {
              const k = neighborId * stride;
              if (data[k + OFFSET_ZOOM] <= zoom)
                continue;
              data[k + OFFSET_ZOOM] = zoom;
              for (let j = 0; j < stride; j++)
                nextData.push(data[k + j]);
            }
          }
        }
      }
      return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
      return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
      return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
      if (data[i + OFFSET_NUM] > 1) {
        const props = this.clusterProps[data[i + OFFSET_PROP]];
        return clone ? Object.assign({}, props) : props;
      }
      const original = this.points[data[i + OFFSET_ID]].properties;
      const result = this.options.map(original);
      return clone && result === original ? Object.assign({}, result) : result;
    }
  };
  function getClusterJSON(data, i, clusterProps) {
    return {
      type: "Feature",
      id: data[i + OFFSET_ID],
      properties: getClusterProperties(data, i, clusterProps),
      geometry: {
        type: "Point",
        coordinates: [xLng(data[i]), yLat(data[i + 1])]
      }
    };
  }
  function getClusterProperties(data, i, clusterProps) {
    const count = data[i + OFFSET_NUM];
    const abbrev = count >= 1e4 ? `${Math.round(count / 1e3)}k` : count >= 1e3 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
      cluster: true,
      cluster_id: data[i + OFFSET_ID],
      point_count: count,
      point_count_abbreviated: abbrev
    });
  }
  function lngX(lng) {
    return lng / 360 + 0.5;
  }
  function latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
  }
  function xLng(x) {
    return (x - 0.5) * 360;
  }
  function yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
  }

  // node_modules/@googlemaps/markerclusterer/dist/index.esm.mjs
  function __rest(s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
          t[p[i]] = s[p[i]];
      }
    return t;
  }
  var MarkerUtils = class {
    static isAdvancedMarkerAvailable(map) {
      return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
      return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
      if (this.isAdvancedMarker(marker)) {
        marker.map = map;
      } else {
        marker.setMap(map);
      }
    }
    static getPosition(marker) {
      if (this.isAdvancedMarker(marker)) {
        if (marker.position) {
          if (marker.position instanceof google.maps.LatLng) {
            return marker.position;
          }
          if (Number.isFinite(marker.position.lat) && Number.isFinite(marker.position.lng)) {
            return new google.maps.LatLng(marker.position.lat, marker.position.lng);
          }
        }
        return new google.maps.LatLng(null);
      }
      return marker.getPosition();
    }
    static getVisible(marker) {
      if (this.isAdvancedMarker(marker)) {
        return true;
      }
      return marker.getVisible();
    }
  };
  var Cluster = class {
    constructor({ markers, position }) {
      this.markers = [];
      if (markers)
        this.markers = markers;
      if (position) {
        if (position instanceof google.maps.LatLng) {
          this._position = position;
        } else {
          this._position = new google.maps.LatLng(position);
        }
      }
    }
    get bounds() {
      if (this.markers.length === 0 && !this._position) {
        return;
      }
      const bounds = new google.maps.LatLngBounds(this._position, this._position);
      for (const marker of this.markers) {
        bounds.extend(MarkerUtils.getPosition(marker));
      }
      return bounds;
    }
    get position() {
      return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */
    get count() {
      return this.markers.filter((m) => MarkerUtils.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */
    push(marker) {
      this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */
    delete() {
      if (this.marker) {
        MarkerUtils.setMap(this.marker, null);
        this.marker = void 0;
      }
      this.markers.length = 0;
    }
  };
  function assertNotNull(value, message = "assertion failed") {
    if (value === null || value === void 0) {
      throw Error(message);
    }
  }
  var AbstractAlgorithm = class {
    constructor({ maxZoom = 16 }) {
      this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */
    noop({ markers }) {
      return noop(markers);
    }
  };
  var noop = (markers) => {
    const clusters = markers.map((marker) => new Cluster({
      position: MarkerUtils.getPosition(marker),
      markers: [marker]
    }));
    return clusters;
  };
  var SuperClusterAlgorithm = class extends AbstractAlgorithm {
    constructor(_a) {
      var { maxZoom, radius = 60 } = _a, options = __rest(_a, ["maxZoom", "radius"]);
      super({ maxZoom });
      this.markers = [];
      this.clusters = [];
      this.state = { zoom: -1 };
      this.superCluster = new Supercluster(Object.assign({ maxZoom: this.maxZoom, radius }, options));
    }
    calculate(input) {
      let changed = false;
      let zoom = input.map.getZoom();
      assertNotNull(zoom);
      zoom = Math.round(zoom);
      const state = { zoom };
      if (!deepEqual(input.markers, this.markers)) {
        changed = true;
        this.markers = [...input.markers];
        const points = this.markers.map((marker) => {
          const position = MarkerUtils.getPosition(marker);
          const coordinates = [position.lng(), position.lat()];
          return {
            type: "Feature",
            geometry: { type: "Point", coordinates },
            properties: { marker }
          };
        });
        this.superCluster.load(points);
      }
      if (!changed) {
        if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) {
          changed = !deepEqual(this.state, state);
        }
      }
      this.state = state;
      if (input.markers.length === 0) {
        this.clusters = [];
        return { clusters: this.clusters, changed };
      }
      if (changed) {
        this.clusters = this.cluster(input);
      }
      return { clusters: this.clusters, changed };
    }
    cluster({ map }) {
      const zoom = map.getZoom();
      assertNotNull(zoom);
      return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(zoom)).map((feature) => this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties }) {
      if (properties.cluster) {
        return new Cluster({
          markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf) => leaf.properties.marker),
          position: { lat, lng }
        });
      }
      const marker = properties.marker;
      return new Cluster({
        markers: [marker],
        position: MarkerUtils.getPosition(marker)
      });
    }
  };
  var ClusterStats = class {
    constructor(markers, clusters) {
      this.markers = { sum: markers.length };
      const clusterMarkerCounts = clusters.map((a) => a.count);
      const clusterMarkerSum = clusterMarkerCounts.reduce((a, b) => a + b, 0);
      this.clusters = {
        count: clusters.length,
        markers: {
          mean: clusterMarkerSum / clusters.length,
          sum: clusterMarkerSum,
          min: Math.min(...clusterMarkerCounts),
          max: Math.max(...clusterMarkerCounts)
        }
      };
    }
  };
  var DefaultRenderer = class {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */
    render({ count, position }, stats, map) {
      const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
      const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
      const title = `Cluster of ${count} markers`, zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
      if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
        const parser = new DOMParser();
        const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
        svgEl.setAttribute("transform", "translate(0 25)");
        const clusterOptions2 = {
          map,
          position,
          zIndex,
          title,
          content: svgEl
        };
        return new google.maps.marker.AdvancedMarkerElement(clusterOptions2);
      }
      const clusterOptions = {
        position,
        zIndex,
        title,
        icon: {
          url: `data:image/svg+xml;base64,${btoa(svg)}`,
          anchor: new google.maps.Point(25, 25)
        }
      };
      return new google.maps.Marker(clusterOptions);
    }
  };
  function extend(type1, type2) {
    for (let property in type2.prototype) {
      type1.prototype[property] = type2.prototype[property];
    }
  }
  var OverlayViewSafe = class _OverlayViewSafe {
    constructor() {
      extend(_OverlayViewSafe, google.maps.OverlayView);
    }
  };
  var MarkerClustererEvents;
  (function(MarkerClustererEvents2) {
    MarkerClustererEvents2["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents2["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents2["CLUSTER_CLICK"] = "click";
    MarkerClustererEvents2["GMP_CLICK"] = "gmp-click";
  })(MarkerClustererEvents || (MarkerClustererEvents = {}));
  var defaultOnClusterClickHandler = (_, cluster, map) => {
    if (cluster.bounds)
      map.fitBounds(cluster.bounds);
  };
  var MarkerClusterer = class extends OverlayViewSafe {
    constructor({ map, markers = [], algorithmOptions = {}, algorithm = new SuperClusterAlgorithm(algorithmOptions), renderer = new DefaultRenderer(), onClusterClick = defaultOnClusterClickHandler }) {
      super();
      this.map = null;
      this.idleListener = null;
      this.markers = [...markers];
      this.clusters = [];
      this.algorithm = algorithm;
      this.renderer = renderer;
      this.onClusterClick = onClusterClick;
      if (map) {
        this.setMap(map);
      }
    }
    addMarker(marker, noDraw) {
      if (this.markers.includes(marker)) {
        return;
      }
      this.markers.push(marker);
      if (!noDraw) {
        this.render();
      }
    }
    addMarkers(markers, noDraw) {
      markers.forEach((marker) => {
        this.addMarker(marker, true);
      });
      if (!noDraw) {
        this.render();
      }
    }
    removeMarker(marker, noDraw) {
      const index = this.markers.indexOf(marker);
      if (index === -1) {
        return false;
      }
      MarkerUtils.setMap(marker, null);
      this.markers.splice(index, 1);
      if (!noDraw) {
        this.render();
      }
      return true;
    }
    removeMarkers(markers, noDraw) {
      let removed = false;
      markers.forEach((marker) => {
        removed = this.removeMarker(marker, true) || removed;
      });
      if (removed && !noDraw) {
        this.render();
      }
      return removed;
    }
    clearMarkers(noDraw) {
      this.markers.length = 0;
      if (!noDraw) {
        this.render();
      }
    }
    /**
     * Recalculates and draws all the marker clusters.
     */
    render() {
      const map = this.getMap();
      if (map instanceof google.maps.Map && map.getProjection()) {
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);
        const { clusters, changed } = this.algorithm.calculate({
          markers: this.markers,
          map,
          mapCanvasProjection: this.getProjection()
        });
        if (changed || changed == void 0) {
          const singleMarker = /* @__PURE__ */ new Set();
          for (const cluster of clusters) {
            if (cluster.markers.length == 1) {
              singleMarker.add(cluster.markers[0]);
            }
          }
          const groupMarkers = [];
          for (const cluster of this.clusters) {
            if (cluster.marker == null) {
              continue;
            }
            if (cluster.markers.length == 1) {
              if (!singleMarker.has(cluster.marker)) {
                MarkerUtils.setMap(cluster.marker, null);
              }
            } else {
              groupMarkers.push(cluster.marker);
            }
          }
          this.clusters = clusters;
          this.renderClusters();
          requestAnimationFrame(() => groupMarkers.forEach((marker) => MarkerUtils.setMap(marker, null)));
        }
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
      }
    }
    onAdd() {
      const map = this.getMap();
      assertNotNull(map);
      this.idleListener = map.addListener("idle", this.render.bind(this));
      this.render();
    }
    onRemove() {
      if (this.idleListener)
        google.maps.event.removeListener(this.idleListener);
      this.reset();
    }
    reset() {
      this.markers.forEach((marker) => MarkerUtils.setMap(marker, null));
      this.clusters.forEach((cluster) => cluster.delete());
      this.clusters = [];
    }
    renderClusters() {
      const stats = new ClusterStats(this.markers, this.clusters);
      const map = this.getMap();
      this.clusters.forEach((cluster) => {
        if (cluster.markers.length === 1) {
          cluster.marker = cluster.markers[0];
        } else {
          cluster.marker = this.renderer.render(cluster, stats, map);
          cluster.markers.forEach((marker) => MarkerUtils.setMap(marker, null));
          if (this.onClusterClick) {
            const markerClickEventName = MarkerUtils.isAdvancedMarker(cluster.marker) ? MarkerClustererEvents.GMP_CLICK : MarkerClustererEvents.CLUSTER_CLICK;
            cluster.marker.addListener(
              markerClickEventName,
              /* istanbul ignore next */
              (event) => {
                google.maps.event.trigger(this, MarkerClustererEvents.CLUSTER_CLICK, cluster);
                this.onClusterClick(event, cluster, map);
              }
            );
          }
        }
        MarkerUtils.setMap(cluster.marker, map);
      });
    }
  };

  // app/scripts/utils/distance.js
  var EARTH_RADIUS_KM = 6371;
  var degreesToRadians = (degrees) => degrees * Math.PI / 180;
  var haversineKm = (lat1, lng1, lat2, lng2) => {
    if (lat1 == null || lng1 == null || lat2 == null || lng2 == null || isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2)) {
      return null;
    }
    const lat1Rad = degreesToRadians(Number(lat1));
    const lat2Rad = degreesToRadians(Number(lat2));
    const dLat = degreesToRadians(Number(lat2) - Number(lat1));
    const dLng = degreesToRadians(Number(lng2) - Number(lng1));
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_KM * c;
  };
  var haversineKmFromPos = (pos1, pos2) => {
    return haversineKm(pos1?.lat, pos1?.lng, pos2?.lat, pos2?.lng);
  };

  // app/scripts/components/MapComponent.js
  var MAP_CONFIG = {
    DEFAULT_ZOOM: 10,
    DETAIL_ZOOM: 14,
    MAP_ID: "DEMO_MAP_ID",
    // Marker optimization settings
    MAX_MARKERS_PER_BATCH: 50,
    BATCH_PROCESSING_DELAY: 16,
    // ~60fps
    VIEWPORT_PADDING: 0.1,
    // 10% padding around viewport
    MAX_VISIBLE_MARKERS: 200,
    MARKER_CACHE_SIZE: 500,
    MAP_MOVE_DEBOUNCE: 500
  };
  var CSS_CLASSES = {
    STORE_ITEM: "jsStoreItem",
    STORE_DETAIL: "jsStoreDetail",
    STORE_LOCATION: "store-location",
    LOCATION_MOBILE: "jsLocationMobile",
    SELECTED: "selected",
    ACTIVE: "active",
    SHOW_SELECTED: "show-store-selected",
    PROPERTY: "property",
    ICON: "icon"
  };
  var EVENTS = {
    LOAD_MARKER: "map:loadMarker",
    PAN_TO: "map:panTo",
    STORE_DETAIL_UPDATED: "store-detail:updated"
  };
  var MOBILE_BREAKPOINT = "(max-width: 768px)";
  var debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
  };
  var batchProcess = (items, batchSize, processor, delay = 16) => {
    return new Promise((resolve) => {
      let index = 0;
      const results = [];
      const processBatch = () => {
        const batch = items.slice(index, index + batchSize);
        const batchResults = batch.map(processor);
        results.push(...batchResults);
        index += batchSize;
        if (index < items.length) {
          setTimeout(processBatch, delay);
        } else {
          resolve(results);
        }
      };
      processBatch();
    });
  };
  var isInViewport = (position, bounds, padding = 0) => {
    if (!bounds)
      return true;
    const { lat, lng } = position;
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const latPadding = (ne.lat() - sw.lat()) * padding;
    const lngPadding = (ne.lng() - sw.lng()) * padding;
    return lat >= sw.lat() - latPadding && lat <= ne.lat() + latPadding && lng >= sw.lng() - lngPadding && lng <= ne.lng() + lngPadding;
  };
  var calculateDistance = (pos1, pos2) => haversineKmFromPos(pos1, pos2);
  !customElements.get("map-component") && customElements.define(
    "map-component",
    class MapComponent extends HTMLElement {
      // Private fields
      #debouncedMapMove;
      #markerCache;
      #activeMarkers;
      #allStores;
      #isProcessingMarkers;
      // Called when element is connected to DOM
      constructor() {
        super();
        this.initMap();
        this.#initializeProperties();
        window.addEventListener(EVENTS.STORE_DETAIL_UPDATED, this.#handleStoreDetailUpdated.bind(this));
      }
      // Private properties initialization
      #initializeProperties() {
        this.config = null;
        this.map = null;
        this.stores = [];
        this.markerClusterer = null;
        this.infoWindow = null;
        this.AdvancedMarkerElement = null;
        this.getSuggest = null;
        this.#markerCache = /* @__PURE__ */ new Map();
        this.#activeMarkers = /* @__PURE__ */ new Set();
        this.#allStores = [];
        this.#isProcessingMarkers = false;
        this.#debouncedMapMove = debounce(this.#handleMapMove.bind(this), MAP_CONFIG.MAP_MOVE_DEBOUNCE);
      }
      // Main initialization method
      async initMap() {
        if (this.querySelector(".jsIconGroup")) {
          this.iconGroup = this.querySelector(".jsIconGroup").content.firstElementChild.cloneNode(true);
        }
        if (this.classList.contains("jsWait")) {
          this.classList.remove("jsWait");
          return;
        }
        try {
          await this.#loadGoogleMapsLibraries();
          this.#loadConfig();
          this.#createMap();
          this.#setupEventListeners();
        } catch (error) {
          console.error("Failed to initialize map:", error);
        }
      }
      // Load configuration from script tag
      #loadConfig() {
        const configScript = this.querySelector('script[type="application/json"]');
        if (!configScript) {
          throw new Error("Map configuration not found");
        }
        this.config = JSON.parse(configScript.textContent);
        if (this.currentLocation) {
          const [lat, lng] = this.currentLocation;
          this.config.startPoint = [lat, lng];
        }
      }
      // Load required Google Maps libraries
      async #loadGoogleMapsLibraries() {
        const [{ Map: Map2 }, { Autocomplete }, { AdvancedMarkerElement }] = await Promise.all([
          google.maps.importLibrary("maps"),
          google.maps.importLibrary("places"),
          google.maps.importLibrary("marker")
        ]);
        this.AdvancedMarkerElement = AdvancedMarkerElement;
        this.infoWindow = new google.maps.InfoWindow();
      }
      // Create the map instance
      #createMap() {
        const {
          zoom = MAP_CONFIG.DEFAULT_ZOOM,
          startPoint: [lat, lng]
        } = this.config;
        this.map = new google.maps.Map(this, {
          center: { lat, lng },
          zoom,
          mapId: MAP_CONFIG.MAP_ID,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
          }
        });
        if (this.config.store?.length > 0) {
          this.#loadMarkers(this.config.store);
        }
      }
      // Setup event listeners
      #setupEventListeners() {
        window.addEventListener(EVENTS.LOAD_MARKER, this.#handleLoadMarker.bind(this));
        window.addEventListener(EVENTS.PAN_TO, this.#handlePanTo.bind(this));
        this.map.addListener("bounds_changed", this.#debouncedMapMove);
        this.map.addListener("zoom_changed", this.#debouncedMapMove);
      }
      // Handle load marker event
      #handleLoadMarker(event) {
        const {
          detail: { stores }
        } = event;
        this.#loadMarkers(stores);
      }
      // Handle pan to event
      #handlePanTo(event) {
        const {
          detail: { latlng }
        } = event;
        this.#panToLocation(latlng);
      }
      // Handle store detail updated event
      #handleStoreDetailUpdated(event) {
        this.initMap();
      }
      // Load markers on the map with optimization
      async #loadMarkers(stores) {
        if (this.#isProcessingMarkers) {
          return;
        }
        this.#isProcessingMarkers = true;
        this.#allStores = stores;
        this.stores = stores;
        try {
          this.#clearExistingMarkers();
          const visibleStores = this.#getVisibleStores(stores);
          const prioritizedStores = this.#prioritizeStores(visibleStores);
          const limitedStores = prioritizedStores.slice(0, MAP_CONFIG.MAX_VISIBLE_MARKERS);
          const markers = await batchProcess(
            limitedStores,
            MAP_CONFIG.MAX_MARKERS_PER_BATCH,
            (store) => this.#createOptimizedMarker(store),
            MAP_CONFIG.BATCH_PROCESSING_DELAY
          );
          const validMarkers = markers.filter((marker) => marker !== null);
          if (this.markerClusterer) {
            this.markerClusterer.clearMarkers();
            this.markerClusterer.addMarkers(validMarkers);
          } else {
            this.markerClusterer = new MarkerClusterer({
              markers: validMarkers,
              map: this.map,
              renderer: {
                render: ({ markers: markers2, position }) => {
                  const clusterElement = document.createElement("div");
                  clusterElement.className = "marker-cluster";
                  clusterElement.setAttribute("role", "button");
                  const strings = this.config?.string?.accessibility;
                  const clusterLabel = strings?.cluster_marker?.replace("{{count}}", markers2.length) || `Cluster of ${markers2.length} store locations. Click to zoom in and see individual stores.`;
                  clusterElement.setAttribute("aria-label", clusterLabel);
                  clusterElement.addEventListener("keydown", (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      clusterElement.click();
                    }
                  });
                  clusterElement.innerHTML = `
                    <div class="marker-cluster__content">
                      ${this.iconGroup.outerHTML}
                      <span class="marker-cluster__count" aria-hidden="true">${markers2.length}</span>
                    </div>
                  `;
                  return new this.AdvancedMarkerElement({
                    position,
                    content: clusterElement,
                    title: `Cluster of ${markers2.length} stores`
                    // Additional accessibility
                  });
                }
              }
            });
          }
        } catch (error) {
          console.error("Error loading markers:", error);
        } finally {
          this.#isProcessingMarkers = false;
        }
      }
      // Pan to specific location
      #panToLocation(latlng) {
        this.map.panTo(latlng);
        this.map.setZoom(MAP_CONFIG.DEFAULT_ZOOM);
      }
      // Create individual marker
      #createMarker(store) {
        const { latitude: lat, longitude: lng, pin, infoWindow } = store;
        const position = { lat: +lat, lng: +lng };
        if (typeof this.AdvancedMarkerElement === "undefined") {
          console.warn("AdvancedMarkerElement not available");
          return null;
        }
        const marker = new this.AdvancedMarkerElement({
          position,
          content: this.#buildMarkerContent(pin, store),
          title: store?.name || "Store location"
          // Additional accessibility
        });
        store.marker = marker;
        this.#setupMarkerEvents(marker, store);
        this.#attachGoToMethod(store, position);
        return marker;
      }
      // Build marker content
      #buildMarkerContent(icon, store = null) {
        const content = document.createElement("div");
        content.classList.add(CSS_CLASSES.PROPERTY);
        content.setAttribute("role", "button");
        const strings = this.config?.string?.accessibility;
        const storeName = store?.name || "Store location";
        const storeAddress = store?.address || "";
        let ariaLabel;
        if (store && strings) {
          if (storeName && storeAddress) {
            ariaLabel = strings.store_marker_with_address?.replace("{{name}}", storeName)?.replace("{{address}}", storeAddress) || `${storeName} at ${storeAddress}`;
          } else if (storeName) {
            ariaLabel = strings.store_marker_with_name?.replace("{{name}}", storeName) || storeName;
          } else {
            ariaLabel = strings.store_marker || "Store location";
          }
        } else {
          ariaLabel = storeAddress ? `${storeName} at ${storeAddress}` : storeName;
        }
        content.setAttribute("aria-label", ariaLabel);
        content.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            content.click();
          }
        });
        content.innerHTML = `<div class="${CSS_CLASSES.ICON}">${icon}</div>`;
        return content;
      }
      // Setup marker event listeners
      #setupMarkerEvents(marker, store) {
        const { latitude: lat, longitude: lng } = store;
        marker.addListener("click", () => {
          this.#handleMarkerClick(lat, lng, store, marker);
        });
      }
      // Handle marker click
      #handleMarkerClick(lat, lng, store, marker) {
        this.#openInfoWindow(store, marker);
        this.#updateStoreSelection(lat, lng);
      }
      // Open info window
      #openInfoWindow(store, marker) {
        this.infoWindow.close();
        this.infoWindow.setContent(store.infoWindow);
        this.infoWindow.open(this.map, marker);
      }
      // Update store selection in UI
      #updateStoreSelection(lat, lng) {
        const isMobile = window.matchMedia(MOBILE_BREAKPOINT).matches;
        const prefix = isMobile ? `.${CSS_CLASSES.LOCATION_MOBILE} ` : "";
        const storeSelector = `${prefix}.${CSS_CLASSES.STORE_ITEM}[data-lat="${lat}"][data-lng="${lng}"]`;
        this.#clearSelections();
        const storeElement = document.querySelector(storeSelector);
        if (storeElement) {
          storeElement.classList.add(CSS_CLASSES.SELECTED);
          storeElement.closest(CSS_CLASSES.STORE_LOCATION)?.classList.add(CSS_CLASSES.SHOW_SELECTED);
        }
      }
      // Clear all selections
      #clearSelections() {
        document.querySelectorAll(`.${CSS_CLASSES.STORE_ITEM}.${CSS_CLASSES.SELECTED}`).forEach((item) => item.classList.remove(CSS_CLASSES.SELECTED));
        document.querySelectorAll(`.${CSS_CLASSES.STORE_DETAIL}.${CSS_CLASSES.ACTIVE}`).forEach((item) => item.classList.remove(CSS_CLASSES.ACTIVE));
      }
      // Attach goTo method to store
      #attachGoToMethod(store, position) {
        store.goTo = () => {
          this.map.panTo(position);
          this.map.setZoom(MAP_CONFIG.DETAIL_ZOOM);
          this.#openInfoWindow(store, store.marker);
        };
      }
      // Public method to set center
      setCenter(lat, lng) {
        const store = this.#findStoreByCoordinates(lat, lng);
        store?.goTo();
      }
      // Find store by coordinates
      #findStoreByCoordinates(lat, lng) {
        return this.stores.find((store) => +store.latitude === +lat && +store.longitude === +lng);
      }
      // Marker optimization methods
      // Handle map movement events
      #handleMapMove = () => {
        if (this.#isProcessingMarkers)
          return;
        if (this.#allStores.length > 0) {
          this.#loadMarkers(this.#allStores);
        }
      };
      // Get stores visible in current viewport
      #getVisibleStores = (stores) => {
        if (!this.map)
          return stores;
        const bounds = this.map.getBounds();
        if (!bounds)
          return stores;
        return stores.filter((store) => {
          const position = {
            lat: +store.latitude,
            lng: +store.longitude
          };
          return isInViewport(position, bounds, MAP_CONFIG.VIEWPORT_PADDING);
        });
      };
      // Prioritize stores by distance from center and importance
      #prioritizeStores = (stores) => {
        if (!this.map)
          return stores;
        const center = this.map.getCenter();
        if (!center)
          return stores;
        const centerPos = {
          lat: center.lat(),
          lng: center.lng()
        };
        return stores.map((store) => ({
          ...store,
          distance: calculateDistance(centerPos, {
            lat: +store.latitude,
            lng: +store.longitude
          })
        })).sort((a, b) => {
          const importanceA = a.importance || 0;
          const importanceB = b.importance || 0;
          if (importanceA !== importanceB) {
            return importanceB - importanceA;
          }
          return a.distance - b.distance;
        });
      };
      // Create optimized marker with caching
      #createOptimizedMarker = (store) => {
        const { latitude: lat, longitude: lng } = store;
        const cacheKey = `${lat}_${lng}`;
        if (this.#markerCache.has(cacheKey)) {
          const cachedMarker = this.#markerCache.get(cacheKey);
          this.#activeMarkers.add(cachedMarker);
          return cachedMarker;
        }
        const marker = this.#createMarker(store);
        if (marker) {
          if (this.#markerCache.size < MAP_CONFIG.MARKER_CACHE_SIZE) {
            this.#markerCache.set(cacheKey, marker);
          }
          this.#activeMarkers.add(marker);
        }
        return marker;
      };
      // Enhanced clear existing markers with cache management
      #clearExistingMarkers() {
        if (this.markerClusterer) {
          this.markerClusterer.clearMarkers();
        }
        this.#activeMarkers.clear();
        if (this.#markerCache.size > MAP_CONFIG.MARKER_CACHE_SIZE * 1.5) {
          this.#cleanupMarkerCache();
        }
      }
      // Clean up marker cache
      #cleanupMarkerCache() {
        const entries = Array.from(this.#markerCache.entries());
        const keepCount = Math.floor(MAP_CONFIG.MARKER_CACHE_SIZE * 0.7);
        if (entries.length > keepCount) {
          this.#markerCache.clear();
          entries.slice(-keepCount).forEach(([key, marker]) => {
            this.#markerCache.set(key, marker);
          });
        }
      }
    }
  );

  // app/scripts/components/StoreLocation.js
  var DISTANCE_CONFIG = {
    UNIT: "km",
    // Default display unit: 'km' or 'mi'
    MILE_TO_KM: 1.609344,
    KM_TO_MILE: 0.621371,
    EARTH_RADIUS_KM: 6371,
    EARTH_RADIUS_MI: 3959
    // Note: All distance calculations are done in kilometers internally
    // for consistency and accuracy. Display unit can be changed via
    // storeLocation.setDistanceUnit('km' | 'mi')
  };
  var CLASS_NAME = {
    STORE_ITEM: "jsStoreItem",
    STORE_DETAIL: "jsStoreDetail",
    STORE_SELECTED: "show-store-selected",
    DISTANCE_VALUE: "jsLocationDistance",
    LOCATION_LIST: "jsLocationList"
  };
  !window.customElements.get("store-location") && customElements.define(
    "store-location",
    class extends HTMLElement {
      constructor() {
        super();
        this.config = JSON.parse(this.querySelector("script[type='application/json']").textContent);
        this.mapEl = this.querySelector("map-component");
        if (this.mapEl) {
          this.config = {
            ...this.config,
            ...this.mapEl.config
          };
        }
        this.locationSearchEl = this.querySelector("location-search");
        this.distanceCache = /* @__PURE__ */ new Map();
        this.maxCacheSize = 100;
        this.originalStoreOrder = null;
        this.getLocations();
        this.#bindEvents();
      }
      #bindEvents() {
        this.addEventListener("location:found", (e) => {
          const { locationName, lat, lng } = e.detail;
          this.onLocationFound(locationName, lat, lng);
        });
        this.addEventListener("search:clear", () => {
          this.#clearSearchState();
        });
        this.addEventListener("search:cleared", () => {
          this.#resetToOriginalOrder();
        });
        this.addEventListener("click", (e) => {
          const { target } = e;
          if (target.closest(`.${CLASS_NAME.STORE_ITEM}`)) {
            this.onStoreClick(target);
          }
        });
      }
      // Handle location found from search component
      async onLocationFound(locationName, lat, lng) {
        if (this.mapEl) {
          this.mapEl.currentLocation = [lat, lng];
        }
        window.dispatchEvent(
          new CustomEvent("map:panTo", {
            detail: {
              latlng: {
                lat,
                lng
              }
            }
          })
        );
        await this.filterStoreByDistance({ lat, lng });
        document.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}.${CLASS_NAME.STORE_SELECTED}`)?.forEach((item) => item.classList.remove(CLASS_NAME.STORE_SELECTED));
      }
      async getLocations() {
        const { url } = this.config;
        const response = await fetch(url);
        const data = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const locationList = this.querySelector(`.${CLASS_NAME.LOCATION_LIST}`);
        if (locationList) {
          const fragment = document.createDocumentFragment();
          for (const node of Array.from(doc.querySelector(".shopify-section").childNodes)) {
            fragment.appendChild(node);
          }
          while (locationList.firstChild) {
            locationList.removeChild(locationList.firstChild);
          }
          locationList.appendChild(fragment);
        }
        const locationJson = this.querySelector("[data-location-json]");
        this.config = {
          ...this.config,
          locations: JSON.parse(locationJson.textContent)
        };
        locationJson.remove();
        await new Promise((resolve) => setTimeout(resolve, 1e3));
        window.dispatchEvent(
          new CustomEvent("map:loadMarker", {
            detail: {
              stores: this.config.locations
            }
          })
        );
        this.#storeOriginalOrder();
        this.#sortStoreItemsByDistance();
      }
      onStoreClick(el) {
        const target = el.closest(`.${CLASS_NAME.STORE_ITEM}`);
        if (!target)
          return;
        document.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}.${CLASS_NAME.STORE_SELECTED}`)?.forEach((item) => item.classList.remove(CLASS_NAME.STORE_SELECTED));
        target.classList.add(CLASS_NAME.STORE_SELECTED);
        const { lat, lng } = target.dataset;
        window.dispatchEvent(
          new CustomEvent("map:panTo", {
            detail: {
              latlng: {
                lat: +lat,
                lng: +lng
              }
            }
          })
        );
      }
      // Helper method to clear search state
      #clearSearchState() {
        this.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}.hidden`).forEach((item) => {
          item.classList.remove("hidden");
          item.removeAttribute("data-distance");
        });
        this.classList.remove("search-distance");
        const noResultElement = this.querySelector(".search-no-result");
        if (noResultElement) {
          noResultElement.classList.add("hidden");
        }
        const locationList = this.querySelector(`.${CLASS_NAME.LOCATION_LIST}`);
        if (locationList) {
          locationList.classList.remove("no-location");
        }
        this.querySelectorAll(`.${CLASS_NAME.DISTANCE_VALUE}`).forEach((element) => {
          element.innerHTML = "";
        });
        this.#resetToOriginalOrder();
      }
      async calculateDistance(latitude1, longitude1, latitude2, longitude2) {
        const cacheKey = `${latitude1.toFixed(4)}_${longitude1.toFixed(4)}_${latitude2.toFixed(4)}_${longitude2.toFixed(4)}`;
        if (this.distanceCache.has(cacheKey)) {
          return this.distanceCache.get(cacheKey);
        }
        try {
          const origin = new google.maps.LatLng(latitude1, longitude1);
          const destination = new google.maps.LatLng(latitude2, longitude2);
          if (!this.service) {
            this.service = new google.maps.DistanceMatrixService();
          }
          const request = {
            origins: [origin],
            destinations: [destination],
            travelMode: "DRIVING",
            avoidHighways: false,
            avoidTolls: false
          };
          const response = await this.service.getDistanceMatrix(request);
          const { rows = [] } = response || {};
          const distanceList = rows.map((i) => {
            i.elements.sort((a, b) => {
              return a.distance.value - b.distance.value;
            });
            const nearest = i.elements[0];
            if (nearest.status == "OK") {
              const distanceInKm = nearest.distance.value / 1e3;
              return this.#formatDistance(distanceInKm);
            }
            return null;
          });
          const result = distanceList[0];
          this.#cacheDistance(cacheKey, result);
          return result;
        } catch (error) {
          console.error("Error calculating distance:", error);
          return this.approximateCalculateDistance(latitude1, longitude1, latitude2, longitude2);
        }
      }
      // Helper method to cache distance with size management
      #cacheDistance(key, value) {
        if (this.distanceCache.size >= this.maxCacheSize) {
          const keysToRemove = Array.from(this.distanceCache.keys()).slice(0, 20);
          keysToRemove.forEach((k) => this.distanceCache.delete(k));
        }
        this.distanceCache.set(key, value);
      }
      approximateCalculateDistance(latitude1, longitude1, latitude2, longitude2) {
        const distanceInKm = haversineKm(latitude1, longitude1, latitude2, longitude2);
        if (distanceInKm == null)
          return null;
        return this.#formatDistance(distanceInKm);
      }
      async filterStoreByDistance({ lat: userLat, lng: userLng }) {
        const { locations } = this.config;
        const { distance: maxDistance = 50 } = this.mapEl.config;
        const maxDistanceKm = this.#normalizeMaxDistance(maxDistance);
        const validStores = (await Promise.all(
          locations.map(async (store) => {
            const { latitude, longitude } = store;
            let distance = this.approximateCalculateDistance(+userLat, +userLng, +latitude, +longitude);
            let isDistanceInvalid = distance !== null ? parseFloat(distance) > maxDistanceKm : true;
            if (!isDistanceInvalid) {
              distance = await this.calculateDistance(+userLat, +userLng, +latitude, +longitude);
              isDistanceInvalid = distance !== null ? parseFloat(distance) > maxDistanceKm : true;
            }
            store.distance = distance;
            return !isDistanceInvalid ? store : null;
          })
        )).filter(Boolean);
        validStores.sort((a, b) => {
          return +a.distance - +b.distance;
        });
        const storeItems = [...this.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}`)];
        storeItems.forEach((storeItem) => {
          const { lat, lng } = storeItem.dataset;
          const store = validStores.find((i) => +i.latitude == +lat && +i.longitude == +lng);
          if (store) {
            storeItem.querySelectorAll(`.${CLASS_NAME.DISTANCE_VALUE}`).forEach((i) => {
              i.innerHTML = store.distance != null ? `${store.distance}${this.#getDistanceUnit()}` : null;
            });
            storeItem.setAttribute("data-distance", store.distance);
            storeItem.classList.remove("hidden");
          } else {
            storeItem.classList.add("hidden");
            storeItem.removeAttribute("data-distance");
          }
        });
        this.querySelector(`.${CLASS_NAME.LOCATION_LIST}`).classList.toggle("no-location", validStores.length == 0);
        this.#sortStoreItemsByDistance();
        this.#updateStoreNearMe(validStores.length);
      }
      #updateStoreNearMe(number) {
        const storeNearMe = this.querySelector(`.jsLocationNearMe`);
        if (!storeNearMe)
          return;
        const currentLocationValue = this.querySelector(`.jsLocationCurrent`);
        const {
          string: { near, store, stores }
        } = this.config;
        let str = `${number} `;
        str += number == 1 ? store : stores;
        str += ` ${near} `;
        storeNearMe.innerHTML = str + currentLocationValue.textContent;
      }
      // Distance formatting methods
      // Format distance based on unit preference
      #formatDistance(distanceInKm) {
        if (DISTANCE_CONFIG.UNIT === "km") {
          return distanceInKm.toFixed(1);
        } else {
          const distanceInMiles = distanceInKm * DISTANCE_CONFIG.KM_TO_MILE;
          return distanceInMiles.toFixed(1);
        }
      }
      // Get distance unit for display
      #getDistanceUnit() {
        return DISTANCE_CONFIG.UNIT === "km" ? "km" : "Mi";
      }
      // Convert miles to kilometers (for backward compatibility)
      #convertMilesToKm(miles) {
        return miles * DISTANCE_CONFIG.MILE_TO_KM;
      }
      // Convert kilometers to miles (for backward compatibility)
      #convertKmToMiles(km) {
        return km * DISTANCE_CONFIG.KM_TO_MILE;
      }
      // Normalize max distance to kilometers
      #normalizeMaxDistance(maxDistance) {
        return maxDistance * DISTANCE_CONFIG.MILE_TO_KM;
      }
      // Sort store items by distance (nearest first)
      #sortStoreItemsByDistance() {
        const locationList = this.querySelector(`.${CLASS_NAME.LOCATION_LIST}`);
        if (!locationList)
          return;
        const storeItems = Array.from(locationList.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}`));
        storeItems.sort((a, b) => {
          const distanceA = a.getAttribute("data-distance");
          const distanceB = b.getAttribute("data-distance");
          if (!distanceA && !distanceB)
            return 0;
          if (!distanceA)
            return 1;
          if (!distanceB)
            return -1;
          return parseFloat(distanceA) - parseFloat(distanceB);
        });
        storeItems.forEach((item) => {
          locationList.appendChild(item);
        });
      }
      // Public method to manually trigger distance sorting
      sortByDistance() {
        this.#sortStoreItemsByDistance();
      }
      // Reset store items to original order (as they appear in HTML)
      #resetToOriginalOrder() {
        const locationList = this.querySelector(`.${CLASS_NAME.LOCATION_LIST}`);
        if (!locationList)
          return;
        const storeItems = Array.from(locationList.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}`));
        if (!this.originalStoreOrder) {
          this.originalStoreOrder = storeItems.map((item) => ({
            element: item,
            originalIndex: Array.from(locationList.children).indexOf(item)
          }));
        }
        const sortedItems = [...this.originalStoreOrder].sort((a, b) => a.originalIndex - b.originalIndex);
        sortedItems.forEach(({ element }) => {
          locationList.appendChild(element);
        });
        this.querySelector(`.jsLocationNearMe`).innerHTML = "";
      }
      // Store the original order of store items
      #storeOriginalOrder() {
        const locationList = this.querySelector(`.${CLASS_NAME.LOCATION_LIST}`);
        if (!locationList)
          return;
        const storeItems = Array.from(locationList.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}`));
        this.originalStoreOrder = storeItems.map((item, index) => ({
          element: item,
          originalIndex: index
        }));
      }
      // Public method to change distance unit preference
      setDistanceUnit(unit) {
        if (unit === "km" || unit === "mi") {
          DISTANCE_CONFIG.UNIT = unit;
          this.#refreshDistanceDisplays();
        } else {
          console.error('Invalid distance unit. Use "km" or "mi"');
        }
      }
      // Get current distance unit
      getDistanceUnit() {
        return DISTANCE_CONFIG.UNIT;
      }
      // Public method to clear search and reset to original order
      clearSearch() {
        if (this.locationSearchEl) {
          this.locationSearchEl.clearSearch();
        }
        this.#clearSearchState();
        this.#resetToOriginalOrder();
      }
      // Refresh all distance displays with new unit
      #refreshDistanceDisplays() {
        const storeItems = this.querySelectorAll(`.${CLASS_NAME.STORE_ITEM}`);
        storeItems.forEach((storeItem) => {
          const distanceElements = storeItem.querySelectorAll(`.${CLASS_NAME.DISTANCE_VALUE}`);
          distanceElements.forEach((element) => {
            const currentText = element.textContent;
            if (currentText && currentText.includes("km") || currentText.includes("Mi")) {
              const numericValue = parseFloat(currentText);
              if (!isNaN(numericValue)) {
                let newDistance;
                if (DISTANCE_CONFIG.UNIT === "km" && currentText.includes("Mi")) {
                  newDistance = this.#convertMilesToKm(numericValue);
                } else if (DISTANCE_CONFIG.UNIT === "mi" && currentText.includes("km")) {
                  newDistance = this.#convertKmToMiles(numericValue);
                } else {
                  newDistance = numericValue;
                }
                element.textContent = `${newDistance.toFixed(1)}${this.#getDistanceUnit()}`;
                const distanceInKm = DISTANCE_CONFIG.UNIT === "km" ? newDistance : this.#convertMilesToKm(newDistance);
                storeItem.setAttribute("data-distance", distanceInKm.toFixed(1));
              }
            }
          });
        });
        this.#sortStoreItemsByDistance();
      }
      // Public method to get saved location data (delegates to search component)
      getSavedLocation() {
        return this.locationSearchEl ? this.locationSearchEl.getSavedLocationData() : null;
      }
      // Health check for geocoding providers (delegates to search component)
      async checkGeocodingProviders() {
        return this.locationSearchEl ? this.locationSearchEl.checkGeocodingProviders() : {};
      }
      // Clear geocoding cache (delegates to search component)
      clearGeocodingCache() {
        if (this.locationSearchEl) {
          this.locationSearchEl.clearGeocodingCache();
        }
      }
      // Get geocoding cache stats (delegates to search component)
      getGeocodingCacheStats() {
        return this.locationSearchEl ? this.locationSearchEl.getGeocodingCacheStats() : {};
      }
      // Get current location coordinates (delegates to search component)
      getCurrentLocationCoords() {
        return this.locationSearchEl ? this.locationSearchEl.getCurrentLocationCoords() : null;
      }
      // Get search input value (delegates to search component)
      getSearchValue() {
        return this.locationSearchEl ? this.locationSearchEl.getValue() : "";
      }
      // Set search input value (delegates to search component)
      setSearchValue(value) {
        if (this.locationSearchEl) {
          this.locationSearchEl.setValue(value);
        }
      }
      // Trigger search manually (delegates to search component)
      triggerSearch() {
        if (this.locationSearchEl) {
          this.locationSearchEl.search();
        }
      }
      // Get current location using geolocation (delegates to search component)
      getCurrentLocation() {
        if (this.locationSearchEl) {
          this.locationSearchEl.getCurrentLocation();
        }
      }
    }
  );

  // app/scripts/components/LocationSearch.js
  var debounce2 = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
  };
  var isValidCache = (timestamp, ttl) => Date.now() - timestamp < ttl;
  var SUGGESTION_CONFIG = {
    CACHE_TTL: 60 * 60 * 1e3,
    // 1 hour
    MIN_QUERY_LENGTH: 2,
    DEBOUNCE_DELAY: 300,
    COUNTRY_FILTER_ENABLED: true
    // Enable country filtering for suggestions
  };
  var SUGGESTION_CSS_CLASSES = {
    NO_TARGET: "no-target"
  };
  var createGeocodingCacheKey = (query) => `geocoding_${query.toLowerCase().trim()}`;
  var isValidGeocodingCache = (data) => {
    return data && Date.now() - data.timestamp < GEOCODING_CONFIG.CACHE_TTL;
  };
  var fetchWithTimeout = async (url, options = {}) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), GEOCODING_CONFIG.REQUEST_TIMEOUT);
    try {
      const response = await fetch(url, {
        ...options,
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response;
    } catch (error) {
      clearTimeout(timeoutId);
      throw error;
    }
  };
  var removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };
  var normalizeAddressQuery = (query) => {
    return removeAccents(query).trim().replace(/\s+/g, " ").replace(/[^\w\s,-]/g, "").toLowerCase();
  };
  var SEARCH_CONFIG = {
    SEARCH_DEBOUNCE_DELAY: 300,
    SUGGESTION_DEBOUNCE_DELAY: 200,
    MIN_SEARCH_LENGTH: 2
  };
  var GEOCODING_CONFIG = {
    CACHE_TTL: 7 * 24 * 60 * 60 * 1e3,
    // 7 days
    MAX_CACHE_SIZE: 200,
    REQUEST_TIMEOUT: 1e4,
    // 10 seconds
    PROVIDERS: {
      GOOGLE: "google",
      NOMINATIM: "nominatim",
      MAPBOX: "mapbox",
      HERE: "here",
      OPENCAGE: "opencage"
    },
    // Provider priority order (fallback sequence)
    FALLBACK_ORDER: ["google", "nominatim", "mapbox", "opencage", "here"]
  };
  var SEARCH_CLASS_NAME = {
    SUGGEST_CONTAINER: "jsLocationSuggest",
    INPUT_SEARCH: "jsLocationSearchInput",
    CURRENT_LOCATION: "jsUseCurrentLocation",
    CURRENT_LOCATION_VALUE: "jsLocationCurrent",
    SEARCH_SUBMIT: "jsSearchSubmit",
    LOCATION_CLEAR: "jsLocationClear"
  };
  !window.customElements.get("location-search") && customElements.define(
    "location-search",
    class extends HTMLElement {
      constructor() {
        super();
        this.inputSearch = this.querySelector(`.${SEARCH_CLASS_NAME.INPUT_SEARCH}`);
        this.suggestContainer = this.querySelector(`.${SEARCH_CLASS_NAME.SUGGEST_CONTAINER}`);
        if (this.querySelector("script[type='application/json']")) {
          this.config = JSON.parse(this.querySelector("script[type='application/json']").textContent);
        }
        this.allowedCountries = this.#parseAllowedCountries();
        this.mapEl = document.querySelector("map-component");
        if (this.mapEl && this.mapEl.config) {
          this.config = {
            ...this.config,
            ...this.mapEl.config
          };
        }
        this.debouncedHandleSearchInput = debounce2(
          this.handleSearchInput.bind(this),
          SEARCH_CONFIG.SEARCH_DEBOUNCE_DELAY
        );
        this.debouncedGetSuggestions = debounce2(this.#fetchSuggestions.bind(this), SUGGESTION_CONFIG.DEBOUNCE_DELAY);
        this.geocodingCache = /* @__PURE__ */ new Map();
        this.currentLocation = null;
        this.lastQuery = "";
        this.#bindEvents();
        window.addEventListener("map:loadMarker", (e) => {
          this.getCurrentLocation();
          this.#loadSavedLocation();
        });
      }
      #bindEvents() {
        if (this.inputSearch) {
          this.inputSearch.addEventListener("input", this.debouncedHandleSearchInput);
        }
        this.addEventListener("click", (e) => {
          const { target } = e;
          this.#onSuggestClick(target);
          if (target.closest(`.${SEARCH_CLASS_NAME.SEARCH_SUBMIT}`)) {
            this.#performSearch();
          }
          if (target.closest(`.${SEARCH_CLASS_NAME.LOCATION_CLEAR}`)) {
            this.clearSearch();
          }
          if (target.closest(`.${SEARCH_CLASS_NAME.CURRENT_LOCATION}`)) {
            this.getCurrentLocation({ type: "click" });
          }
          if (!target.closest(`.${SEARCH_CLASS_NAME.SUGGEST_CONTAINER}`)) {
            this.#hideSuggestions();
          }
          if (target.closest(`.${SEARCH_CLASS_NAME.INPUT_SEARCH}`)) {
            const currentValue = this.inputSearch.value.trim();
            if (currentValue.length >= SEARCH_CONFIG.MIN_SEARCH_LENGTH) {
              this.#showSuggestions();
              this.#showCachedSuggestions(currentValue);
            }
          }
        });
        document.addEventListener("keydown", (e) => {
          const activeElement = document.activeElement;
          const links = Array.from(this.querySelectorAll(`.${SEARCH_CLASS_NAME.SUGGEST_CONTAINER} a`));
          if (!activeElement.classList.contains(SEARCH_CLASS_NAME.INPUT_SEARCH) && !links.includes(activeElement))
            return;
          let currentIndex = links.indexOf(activeElement) || 0;
          switch (e.key) {
            case "Enter":
              e.preventDefault();
              if (activeElement.classList.contains(SEARCH_CLASS_NAME.INPUT_SEARCH)) {
                this.#performSearch();
              }
              if (links.includes(activeElement)) {
                const selectedValue = activeElement.textContent;
                this.inputSearch.value = selectedValue;
                this.lastQuery = selectedValue;
                this.#performSearch();
              }
              break;
            case "Tab":
            case "ArrowDown":
              e.preventDefault();
              const nextIndex = (currentIndex + 1) % links.length;
              links[nextIndex].focus();
              break;
            case "ArrowUp":
              e.preventDefault();
              const prevIndex = (currentIndex - 1 + links.length) % links.length;
              links[prevIndex].focus();
              break;
          }
        });
      }
      // Load saved location from localStorage on component initialization
      #loadSavedLocation() {
        try {
          const savedLocationData = localStorage.getItem("lastLocationByUser");
          if (savedLocationData) {
            const parsedData = JSON.parse(savedLocationData);
            if (parsedData && parsedData.locationName && parsedData.location) {
              this.inputSearch.value = parsedData.locationName;
              setTimeout(() => {
                this.search();
              }, 100);
            }
          }
        } catch (error) {
          console.warn("Error loading saved location from localStorage:", error);
        }
      }
      // Save location to localStorage
      #saveLocationToStorage(locationName, coordinates) {
        try {
          const locationData = {
            locationName,
            location: coordinates
            // Array [lat, lng]
          };
          localStorage.setItem("lastLocationByUser", JSON.stringify(locationData));
        } catch (error) {
          console.warn("Error saving location to localStorage:", error);
        }
      }
      // Get saved location data from localStorage
      getSavedLocationData() {
        try {
          const savedLocationData = localStorage.getItem("lastLocationByUser");
          if (savedLocationData) {
            return JSON.parse(savedLocationData);
          }
        } catch (error) {
          console.warn("Error getting saved location from localStorage:", error);
        }
        return null;
      }
      // Clear saved location from localStorage
      #clearSavedLocation() {
        try {
          localStorage.removeItem("lastLocationByUser");
        } catch (error) {
          console.warn("Error clearing saved location from localStorage:", error);
        }
      }
      getCurrentLocation(type = null) {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const latitude = position.coords.latitude;
              const longitude = position.coords.longitude;
              this.currentLocation = [latitude, longitude];
              this.inputSearch.value = this.config.string.current_location;
              this.#saveLocationToStorage(this.config.string.current_location, [latitude, longitude]);
              this.#dispatchLocationFound(this.config.string.current_location, latitude, longitude);
            },
            (error) => {
              this.#dispatchLocationError(error);
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  if (type === "click") {
                    alert("User denied the request for Geolocation.");
                  } else {
                    console.log("User denied the request for Geolocation.");
                  }
                  break;
                case error.POSITION_UNAVAILABLE:
                  console.log("Location information is unavailable.");
                  break;
                case error.TIMEOUT:
                  console.log("The request to get user location timed out.");
                  break;
                default:
                  console.log("An unknown error occurred.");
              }
            }
          );
        }
      }
      handleSearchInput() {
        const value = this.inputSearch.value.trim();
        if (value.length === 0) {
          this.lastQuery = "";
          this.#clearSearchState();
          this.#clearSuggestionContent();
          this.#hideSuggestions();
          return;
        }
        const isNewInput = value !== this.lastQuery;
        if (value.length >= SEARCH_CONFIG.MIN_SEARCH_LENGTH) {
          this.#showSuggestions();
          if (isNewInput) {
            this.lastQuery = value;
            this.getSuggestions(value);
          } else {
            this.#showCachedSuggestions(value);
          }
        } else {
          this.#hideSuggestions();
        }
      }
      // Helper method to clear search state
      #clearSearchState() {
        this.dispatchEvent(
          new CustomEvent("search:clear", {
            bubbles: true,
            detail: {}
          })
        );
      }
      // Helper method to show suggestions
      #showSuggestions() {
        if (this.suggestContainer) {
          this.suggestContainer.classList.remove("hidden");
        }
      }
      // Helper method to hide suggestions
      #hideSuggestions() {
        if (this.suggestContainer) {
          this.suggestContainer.classList.add("hidden");
        }
      }
      // Helper method to show cached suggestions for existing input value
      #showCachedSuggestions(query) {
        if (!this.suggestContainer) {
          return;
        }
        const cachedData = this.#getCachedSuggestions(query);
        if (cachedData && cachedData.length > 0) {
          this.#renderSuggestions(this.suggestContainer, cachedData);
        }
      }
      // Helper method to explicitly clear suggestion content
      #clearSuggestionContent() {
        if (this.suggestContainer) {
          this.suggestContainer.innerHTML = "";
        }
      }
      // Helper method to perform immediate search (bypass debounce)
      #performSearch() {
        this.#hideSuggestions();
        this.search();
      }
      async getCoordinatesFromZipcode(value) {
        const normalizedQuery = normalizeAddressQuery(value);
        const cacheKey = createGeocodingCacheKey(normalizedQuery);
        const cachedResult = this.#getGeocodingCache(cacheKey);
        if (cachedResult) {
          return cachedResult;
        }
        for (const provider of GEOCODING_CONFIG.FALLBACK_ORDER) {
          try {
            const coordinates = await this.#geocodeWithProvider(provider, normalizedQuery);
            console.log("coordinates", { provider, coordinates });
            if (coordinates && coordinates[0] && coordinates[1]) {
              this.#cacheGeocodingResult(cacheKey, coordinates);
              return coordinates;
            }
          } catch (error) {
            console.warn(`Geocoding failed with ${provider}:`, error.message);
            continue;
          }
        }
        this.#showGeocodingError(value);
        return [null, null];
      }
      // Get cached geocoding result
      #getGeocodingCache(cacheKey) {
        const cached = this.geocodingCache.get(cacheKey);
        if (cached && isValidGeocodingCache(cached)) {
          return cached.coordinates;
        }
        return null;
      }
      // Cache geocoding result
      #cacheGeocodingResult(cacheKey, coordinates) {
        if (this.geocodingCache.size >= GEOCODING_CONFIG.MAX_CACHE_SIZE) {
          const oldestKey = this.geocodingCache.keys().next().value;
          this.geocodingCache.delete(oldestKey);
        }
        this.geocodingCache.set(cacheKey, {
          coordinates,
          timestamp: Date.now()
        });
      }
      // Geocode using specific provider
      async #geocodeWithProvider(provider, query) {
        switch (provider) {
          case GEOCODING_CONFIG.PROVIDERS.GOOGLE:
            return this.#geocodeWithGoogle(query);
          case GEOCODING_CONFIG.PROVIDERS.NOMINATIM:
            return this.#geocodeWithNominatim(query);
          case GEOCODING_CONFIG.PROVIDERS.MAPBOX:
            return this.#geocodeWithMapbox(query);
          case GEOCODING_CONFIG.PROVIDERS.OPENCAGE:
            return this.#geocodeWithOpenCage(query);
          case GEOCODING_CONFIG.PROVIDERS.HERE:
            return this.#geocodeWithHere(query);
          default:
            throw new Error(`Unknown geocoding provider: ${provider}`);
        }
      }
      // Google Geocoding API
      async #geocodeWithGoogle(query) {
        const API_KEY = this.config.apiKey;
        if (!API_KEY) {
          throw new Error("Google API key not available");
        }
        const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(query)}&key=${API_KEY}`;
        const response = await fetchWithTimeout(geocodeUrl);
        const data = await response.json();
        if (data.status === "OK" && data.results.length > 0) {
          const location = data.results[0].geometry.location;
          return [location.lat, location.lng];
        } else {
          throw new Error(`Google Geocoding failed: ${data.status}`);
        }
      }
      // OpenStreetMap Nominatim API (free, no API key required)
      async #geocodeWithNominatim(query) {
        const geocodeUrl = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=1&addressdetails=1`;
        const response = await fetchWithTimeout(geocodeUrl, {
          headers: {
            "User-Agent": "StoreLocator/1.0 (Contact: webmaster@example.com)"
            // Required by Nominatim
          }
        });
        const data = await response.json();
        if (data.length > 0) {
          const result = data[0];
          return [parseFloat(result.lat), parseFloat(result.lon)];
        } else {
          throw new Error("Nominatim: No results found");
        }
      }
      // MapBox Geocoding API
      async #geocodeWithMapbox(query) {
        const API_KEY = this.config.mapboxApiKey;
        if (!API_KEY) {
          throw new Error("MapBox API key not available");
        }
        const geocodeUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?access_token=${API_KEY}&limit=1`;
        const response = await fetchWithTimeout(geocodeUrl);
        const data = await response.json();
        if (data.features && data.features.length > 0) {
          const coordinates = data.features[0].center;
          return [coordinates[1], coordinates[0]];
        } else {
          throw new Error("MapBox: No results found");
        }
      }
      // OpenCage Geocoding API
      async #geocodeWithOpenCage(query) {
        const API_KEY = this.config.opencageApiKey;
        if (!API_KEY) {
          throw new Error("OpenCage API key not available");
        }
        const geocodeUrl = `https://api.opencagedata.com/geocode/v1/json?q=${encodeURIComponent(query)}&key=${API_KEY}&limit=1&no_annotations=1`;
        const response = await fetchWithTimeout(geocodeUrl);
        const data = await response.json();
        if (data.results && data.results.length > 0) {
          const result = data.results[0];
          return [result.geometry.lat, result.geometry.lng];
        } else {
          throw new Error("OpenCage: No results found");
        }
      }
      // HERE Geocoding API
      async #geocodeWithHere(query) {
        const API_KEY = this.config.hereApiKey;
        if (!API_KEY) {
          throw new Error("HERE API key not available");
        }
        const geocodeUrl = `https://geocode.search.hereapi.com/v1/geocode?q=${encodeURIComponent(query)}&apikey=${API_KEY}&limit=1`;
        const response = await fetchWithTimeout(geocodeUrl);
        const data = await response.json();
        if (data.items && data.items.length > 0) {
          const position = data.items[0].position;
          return [position.lat, position.lng];
        } else {
          throw new Error("HERE: No results found");
        }
      }
      #onSuggestClick(el) {
        const li = el.closest("li");
        if (li) {
          const selectedValue = li.textContent.trim();
          this.inputSearch.value = selectedValue;
          this.lastQuery = selectedValue;
          this.#performSearch();
        }
      }
      async search() {
        const value = this.inputSearch.value;
        if (value.length < SEARCH_CONFIG.MIN_SEARCH_LENGTH) {
          return;
        }
        const currentLocationValue = this.querySelector(`.${SEARCH_CLASS_NAME.CURRENT_LOCATION_VALUE}`);
        if (currentLocationValue) {
          currentLocationValue.textContent = value;
        }
        let lat, lng;
        if (value == this.config.string.current_location) {
          [lat, lng] = this.currentLocation;
        } else {
          [lat, lng] = await this.getCoordinatesFromZipcode(value);
        }
        if (!lat && !lng) {
          return;
        }
        this.#saveLocationToStorage(value, [lat, lng]);
        this.#dispatchLocationFound(value, lat, lng);
      }
      // Dispatch events for communication with parent components
      #dispatchLocationFound(locationName, lat, lng) {
        this.dispatchEvent(
          new CustomEvent("location:found", {
            bubbles: true,
            detail: {
              locationName,
              lat,
              lng
            }
          })
        );
      }
      #dispatchLocationError(error) {
        this.dispatchEvent(
          new CustomEvent("location:error", {
            bubbles: true,
            detail: {
              error
            }
          })
        );
      }
      // Public method to clear search
      clearSearch() {
        this.inputSearch.value = "";
        this.lastQuery = "";
        this.#clearSearchState();
        this.#clearSuggestionContent();
        const currentLocationValue = this.querySelector(`.${SEARCH_CLASS_NAME.CURRENT_LOCATION_VALUE}`);
        if (currentLocationValue) {
          currentLocationValue.textContent = "";
        }
        this.#clearSavedLocation();
        this.dispatchEvent(
          new CustomEvent("search:cleared", {
            bubbles: true,
            detail: {}
          })
        );
      }
      // Get available geocoding providers
      #getAvailableProviders() {
        const available = [];
        if (this.config.apiKey)
          available.push(GEOCODING_CONFIG.PROVIDERS.GOOGLE);
        if (this.config.mapboxApiKey)
          available.push(GEOCODING_CONFIG.PROVIDERS.MAPBOX);
        if (this.config.opencageApiKey)
          available.push(GEOCODING_CONFIG.PROVIDERS.OPENCAGE);
        if (this.config.hereApiKey)
          available.push(GEOCODING_CONFIG.PROVIDERS.HERE);
        available.push(GEOCODING_CONFIG.PROVIDERS.NOMINATIM);
        return available;
      }
      // Enhanced error handling with user-friendly messages
      #getGeocodingErrorMessage(address) {
        const availableProviders = this.#getAvailableProviders();
        if (availableProviders.length === 1 && availableProviders[0] === GEOCODING_CONFIG.PROVIDERS.NOMINATIM) {
          return `Unable to find location "${address}". Please try a more specific address or add API keys for additional geocoding services.`;
        } else {
          return `Unable to find location "${address}". Please check your address and try again.`;
        }
      }
      // Show geocoding error to user
      #showGeocodingError(address) {
        const errorMessage = this.#getGeocodingErrorMessage(address);
        console.warn("Geocoding Error:", errorMessage);
        this.dispatchEvent(
          new CustomEvent("geocoding:error", {
            bubbles: true,
            detail: {
              address,
              message: errorMessage,
              availableProviders: this.#getAvailableProviders()
            }
          })
        );
      }
      // Clear geocoding cache (useful for troubleshooting)
      clearGeocodingCache() {
        this.geocodingCache.clear();
      }
      // Get geocoding cache stats
      getGeocodingCacheStats() {
        return {
          size: this.geocodingCache.size,
          maxSize: GEOCODING_CONFIG.MAX_CACHE_SIZE,
          availableProviders: this.#getAvailableProviders()
        };
      }
      // Health check for geocoding providers (optional diagnostic method)
      async checkGeocodingProviders() {
        const testQuery = "New York, NY";
        const results = {};
        for (const provider of GEOCODING_CONFIG.FALLBACK_ORDER) {
          try {
            const start = performance.now();
            const coordinates = await this.#geocodeWithProvider(provider, testQuery);
            const end = performance.now();
            results[provider] = {
              status: "success",
              coordinates,
              responseTime: Math.round(end - start)
            };
          } catch (error) {
            results[provider] = {
              status: "failed",
              error: error.message
            };
          }
        }
        console.log("Geocoding providers health check:", results);
        return results;
      }
      // Public API methods
      getValue() {
        return this.inputSearch.value;
      }
      setValue(value) {
        this.inputSearch.value = value;
        this.lastQuery = value.trim();
      }
      getCurrentLocationCoords() {
        return this.currentLocation;
      }
      // Get search input element
      getInputElement() {
        return this.inputSearch;
      }
      // Get suggestion container
      getSuggestionContainer() {
        return this.suggestContainer;
      }
      // ===== COUNTRY MANAGEMENT METHODS =====
      // Get current allowed countries
      getAllowedCountries() {
        return [...this.allowedCountries];
      }
      // Set allowed countries programmatically
      setAllowedCountries(countriesString) {
        if (typeof countriesString !== "string") {
          console.warn("setAllowedCountries expects a comma-separated string of country names");
          return;
        }
        if (!this.config) {
          this.config = {};
        }
        this.config.allowedCountries = countriesString;
        this.allowedCountries = this.#parseAllowedCountries();
        this.#clearCountrySpecificCache();
      }
      // Add a country to the allowed list
      addAllowedCountry(countryName) {
        if (!countryName || typeof countryName !== "string") {
          console.warn("addAllowedCountry expects a valid country name string");
          return;
        }
        const normalizedCountry = countryName.trim().toLowerCase();
        if (!this.allowedCountries.includes(normalizedCountry)) {
          this.allowedCountries.push(normalizedCountry);
          if (!this.config) {
            this.config = {};
          }
          this.config.allowedCountries = this.allowedCountries.join(", ");
          this.#clearCountrySpecificCache();
        }
      }
      // Remove a country from the allowed list
      removeAllowedCountry(countryName) {
        if (!countryName || typeof countryName !== "string") {
          console.warn("removeAllowedCountry expects a valid country name string");
          return;
        }
        const normalizedCountry = countryName.trim().toLowerCase();
        const index = this.allowedCountries.indexOf(normalizedCountry);
        if (index > -1) {
          this.allowedCountries.splice(index, 1);
          if (!this.config) {
            this.config = {};
          }
          this.config.allowedCountries = this.allowedCountries.join(", ");
          this.#clearCountrySpecificCache();
        }
      }
      // Clear all allowed countries (disable country filtering)
      clearAllowedCountries() {
        this.allowedCountries = [];
        if (this.config) {
          delete this.config.allowedCountries;
        }
        this.#clearCountrySpecificCache();
      }
      // Enable or disable country filtering
      setCountryFilterEnabled(enabled) {
        SUGGESTION_CONFIG.COUNTRY_FILTER_ENABLED = Boolean(enabled);
        this.#clearCountrySpecificCache();
      }
      // Check if country filtering is enabled
      isCountryFilterEnabled() {
        return SUGGESTION_CONFIG.COUNTRY_FILTER_ENABLED;
      }
      // Clear country-specific cache entries
      #clearCountrySpecificCache() {
        try {
          const keysToRemove = [];
          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith("autocomplete_")) {
              keysToRemove.push(key);
            }
          }
          keysToRemove.forEach((key) => localStorage.removeItem(key));
        } catch (error) {
          console.warn("Error clearing country-specific cache:", error);
        }
      }
      // Get country filtering status and configuration
      getCountryFilterStatus() {
        return {
          enabled: SUGGESTION_CONFIG.COUNTRY_FILTER_ENABLED,
          allowedCountries: [...this.allowedCountries],
          totalCountries: this.allowedCountries.length
        };
      }
      // ===== BACKWARD COMPATIBILITY METHODS =====
      // These methods are deprecated but maintained for backward compatibility
      // @deprecated Use getAllowedCountries() instead
      getAllowedAreas() {
        console.warn("getAllowedAreas() is deprecated, use getAllowedCountries() instead");
        return this.getAllowedCountries();
      }
      // @deprecated Use setAllowedCountries() instead
      setAllowedAreas(areasString) {
        console.warn("setAllowedAreas() is deprecated, use setAllowedCountries() instead");
        this.setAllowedCountries(areasString);
      }
      // @deprecated Use addAllowedCountry() instead
      addAllowedArea(areaName) {
        console.warn("addAllowedArea() is deprecated, use addAllowedCountry() instead");
        this.addAllowedCountry(areaName);
      }
      // @deprecated Use removeAllowedCountry() instead
      removeAllowedArea(areaName) {
        console.warn("removeAllowedArea() is deprecated, use removeAllowedCountry() instead");
        this.removeAllowedCountry(areaName);
      }
      // @deprecated Use clearAllowedCountries() instead
      clearAllowedAreas() {
        console.warn("clearAllowedAreas() is deprecated, use clearAllowedCountries() instead");
        this.clearAllowedCountries();
      }
      // @deprecated Use setCountryFilterEnabled() instead
      setAreaFilterEnabled(enabled) {
        console.warn("setAreaFilterEnabled() is deprecated, use setCountryFilterEnabled() instead");
        this.setCountryFilterEnabled(enabled);
      }
      // @deprecated Use isCountryFilterEnabled() instead
      isAreaFilterEnabled() {
        console.warn("isAreaFilterEnabled() is deprecated, use isCountryFilterEnabled() instead");
        return this.isCountryFilterEnabled();
      }
      // @deprecated Use getCountryFilterStatus() instead
      getAreaFilterStatus() {
        console.warn("getAreaFilterStatus() is deprecated, use getCountryFilterStatus() instead");
        const status = this.getCountryFilterStatus();
        return {
          enabled: status.enabled,
          allowedAreas: status.allowedCountries,
          // Map to old property name
          totalAreas: status.totalCountries
        };
      }
      // ===== SUGGESTION METHODS (moved from MapComponent) =====
      // Public method to get suggestions
      async getSuggestions(query) {
        const resultsElement = this.suggestContainer;
        if (!resultsElement) {
          console.warn("Results element not found");
          return;
        }
        if (query.length < SUGGESTION_CONFIG.MIN_QUERY_LENGTH) {
          this.#clearSuggestions(resultsElement);
          return;
        }
        this.#clearSuggestionContent();
        await this.debouncedGetSuggestions(query, resultsElement);
      }
      // Clear suggestions
      #clearSuggestions(resultsElement) {
        resultsElement.innerHTML = "";
      }
      // Fetch suggestions with caching
      async #fetchSuggestions(query, resultsElement) {
        try {
          const cachedData = this.#getCachedSuggestions(query);
          if (cachedData) {
            this.#renderSuggestions(resultsElement, cachedData);
            return;
          }
          const suggestions = await this.#fetchGooglePlacesSuggestions(query);
          this.#cacheSuggestions(query, suggestions);
          this.#renderSuggestions(resultsElement, suggestions);
        } catch (error) {
          console.error("Error fetching suggestions:", error);
          this.#clearSuggestions(resultsElement);
        }
      }
      // Parse allowed countries from configuration
      #parseAllowedCountries() {
        if (!this.config || !this.config.allowedCountries) {
          if (this.config && this.config.allowedAreas) {
            console.warn("allowedAreas is deprecated, please use allowedCountries instead");
            return this.config.allowedAreas.split(",").map((country) => country.trim().toLowerCase()).filter((country) => country.length > 0);
          }
          return [];
        }
        const countries = this.config.allowedCountries.split(",").map((country) => country.trim().toLowerCase()).filter((country) => country.length > 0);
        return countries.map((country) => this.#expandCountryCode(country));
      }
      // Expand ISO country codes to full country names
      #expandCountryCode(countryInput) {
        const countryCodeMap = {
          ca: "canada",
          us: "united states",
          usa: "united states",
          fr: "france",
          de: "germany",
          gb: "united kingdom",
          uk: "united kingdom",
          au: "australia",
          jp: "japan",
          cn: "china",
          in: "india",
          br: "brazil",
          mx: "mexico",
          it: "italy",
          es: "spain",
          ru: "russia",
          kr: "south korea",
          nl: "netherlands",
          se: "sweden",
          no: "norway",
          dk: "denmark",
          fi: "finland",
          ch: "switzerland",
          at: "austria",
          be: "belgium",
          pt: "portugal",
          pl: "poland",
          cz: "czech republic",
          hu: "hungary",
          gr: "greece",
          tr: "turkey",
          il: "israel",
          ae: "united arab emirates",
          sa: "saudi arabia",
          eg: "egypt",
          za: "south africa",
          ng: "nigeria",
          ke: "kenya",
          ar: "argentina",
          cl: "chile",
          co: "colombia",
          pe: "peru",
          ve: "venezuela",
          th: "thailand",
          vn: "vietnam",
          sg: "singapore",
          my: "malaysia",
          id: "indonesia",
          ph: "philippines",
          nz: "new zealand"
        };
        return countryCodeMap[countryInput] || countryInput;
      }
      // Check if a suggestion matches allowed countries
      #isLocationInAllowedCountries(suggestionText) {
        if (!SUGGESTION_CONFIG.COUNTRY_FILTER_ENABLED || this.allowedCountries.length === 0) {
          return true;
        }
        const normalizedSuggestion = suggestionText.toLowerCase();
        return this.allowedCountries.some((country) => normalizedSuggestion.includes(country));
      }
      // Filter suggestions based on allowed countries
      #filterSuggestionsByCountry(suggestions) {
        if (!SUGGESTION_CONFIG.COUNTRY_FILTER_ENABLED || this.allowedCountries.length === 0) {
          return suggestions;
        }
        return suggestions.filter((suggestion) => this.#isLocationInAllowedCountries(suggestion));
      }
      // Create country-aware cache key
      #createCountryAwareCacheKey(prefix, query) {
        const countryHash = this.allowedCountries.length > 0 ? this.allowedCountries.sort().join("|") : "all";
        return `${prefix}_${query}_${countryHash}`;
      }
      // Get cached suggestions
      #getCachedSuggestions(query) {
        const cacheKey = this.#createCountryAwareCacheKey("autocomplete", query);
        const cachedData = localStorage.getItem(cacheKey);
        if (!cachedData)
          return null;
        const { data, timestamp } = JSON.parse(cachedData);
        return isValidCache(timestamp, SUGGESTION_CONFIG.CACHE_TTL) ? data : null;
      }
      // Fetch suggestions from Google Places API
      async #fetchGooglePlacesSuggestions(query) {
        const { AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary("places");
        const token = new AutocompleteSessionToken();
        const request = {
          input: query,
          sessionToken: token
        };
        if (this.allowedCountries.length > 0) {
          request.locationBias = {
            radius: 5e4,
            // 50km radius for country-level filtering
            center: await this.#getCountryCenter(this.allowedCountries[0])
          };
        }
        const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
        const rawSuggestions = suggestions.map(({ placePrediction }) => placePrediction.text.toString());
        return this.#filterSuggestionsByCountry(rawSuggestions);
      }
      // Get center coordinates for a country (for location bias)
      async #getCountryCenter(countryName) {
        try {
          const coordinates = await this.getCoordinatesFromZipcode(countryName);
          if (coordinates[0] && coordinates[1]) {
            return { lat: coordinates[0], lng: coordinates[1] };
          }
        } catch (error) {
          console.warn(`Could not get coordinates for country: ${countryName}`, error);
        }
        const countryDefaults = {
          canada: { lat: 56.1304, lng: -106.3468 },
          "united states": { lat: 39.8283, lng: -98.5795 },
          usa: { lat: 39.8283, lng: -98.5795 },
          france: { lat: 46.2276, lng: 2.2137 },
          germany: { lat: 51.1657, lng: 10.4515 },
          "united kingdom": { lat: 55.3781, lng: -3.436 },
          uk: { lat: 55.3781, lng: -3.436 },
          australia: { lat: -25.2744, lng: 133.7751 },
          japan: { lat: 36.2048, lng: 138.2529 },
          china: { lat: 35.8617, lng: 104.1954 },
          india: { lat: 20.5937, lng: 78.9629 },
          brazil: { lat: -14.235, lng: -51.9253 },
          mexico: { lat: 23.6345, lng: -102.5528 }
        };
        const normalizedCountry = countryName.toLowerCase();
        return countryDefaults[normalizedCountry] || { lat: 0, lng: 0 };
      }
      // Cache suggestions
      #cacheSuggestions(query, suggestions) {
        const cacheKey = this.#createCountryAwareCacheKey("autocomplete", query);
        const cacheData = {
          data: suggestions,
          timestamp: Date.now()
        };
        localStorage.setItem(cacheKey, JSON.stringify(cacheData));
      }
      // Render suggestions in the UI
      #renderSuggestions(resultsElement, suggestions) {
        resultsElement.innerHTML = "";
        suggestions.forEach((text) => {
          const listItem = this.#createSuggestionItem(text);
          resultsElement.appendChild(listItem);
        });
      }
      // Create suggestion item
      #createSuggestionItem(text) {
        const listItem = document.createElement("li");
        const anchor = document.createElement("a");
        anchor.href = "javascript:void(0);";
        anchor.textContent = text;
        anchor.className = SUGGESTION_CSS_CLASSES.NO_TARGET;
        anchor.setAttribute("tabindex", "0");
        listItem.appendChild(anchor);
        return listItem;
      }
    }
  );
})();
